import React, { useEffect, useState, useRef, useCallback } from "react";
import Sidebar from "../Sidebar/Sidebar.jsx";
import Topbar from "../Topbar/Topbar.jsx";
import "../../Modules/Tickets/Ticketslist.css";
import Ticketstableview from "./Ticketstableview.jsx";
import Ticketslistview from "./TicketsMailView.jsx";
import Ticketscardview from "./Ticketscardview.jsx";
import rectangle from "../../Assets/svg/rectangle.svg";
import lar from "../../Assets/svg/lar.svg";
import rar from "../../Assets/svg/rar.svg";
import arrows from "../../Assets/svg/sort_blue.svg";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { Container, Row, Col, Toast, ToastContainer } from "react-bootstrap";
import tableActive from "../../Assets/svg/table-active.svg";
import tableInActive from "../../Assets/svg/table-inactive.svg";
import cardActive from "../../Assets/svg/card-active.svg";
import cardInActive from "../../Assets/svg/card-inactive.svg";
import listActive from "../../Assets/svg/listing-active.svg";
import listInActive from "../../Assets/svg/listing-inactive.svg";
import calendarActive from "../../Assets/svg/calendar-active.svg";
import calendarInActive from "../../Assets/svg/calendar-inactive.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { useGlobal } from "../../GlobalContext.js";
import { useUI } from "../../UIContext";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { DateRangePicker } from "react-date-range";
import { ReactComponent as CalendarIcon } from "../../Assets/svg/calendar.svg";
import { ReactComponent as CalendarPurpleIcon } from "../../Assets/svg/calendar-purple.svg";
import { ReactComponent as CalendarClose } from "../../Assets/svg/close1.svg";
import moment from "moment";
import uploadIcon from "../../Assets/svg/upload-icon.svg";
import downloadIcon from "../../Assets/svg/download-icon.svg";
import LoaderModal from "../common/Loader.js";
import subTicketIcon from "../../Assets/svg/sub-ticket-icon.svg";
import TicketCalendar from "./ticket-calendar/Calendar-View.js";
import close from "../../Assets/svg/close-icon.svg";
import SearchWithAPI from "../common/searchbox/searchbox.js";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import filter from "../../Assets/svg/filter-modal.svg";
import lens from "../../Assets/svg/lens.svg";
import arrowDown from "../../Assets/svg/arrow-down.svg";
import calendar from "../../Assets/svg/calendar.svg";
import calendarOutline from "../../Assets/svg/calendar.svg";
import BulkStatusUpdateModal from "./modal/bulk-status-update.js";
import BulkAssignUpdateModal from "./modal/bulk-assign-update.js";

import closeIcon from "../../Assets/svg/close-red.svg";
import exportBtn from "../../Assets/svg/bl_export_ic.svg";
import StatusUpdateModal from "./modal/status-update.js";
import multiIcon from "../../Assets/svg/merge.svg";
import checkIcon from "../../Assets/svg/bulk_update.svg";
import editIcon from "../../Assets/svg/edit_blue.svg";
import MultiSelectDropDown from "../common/searchbox/multi-select-dropdown.js";
import { Dropdown, DropdownButton, Spinner } from "react-bootstrap";
import { apiCall } from "../../services/api-service.js";
import { getEnabledFieldApi } from "./Ticketapi.js";

export default function Ticketslist() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;
  const { rolePermissionList } = useGlobal();
  const { isCollapsed } = useUI();
  const location = useLocation();
  const navigate = useNavigate();
  const TICKET_LIST_STATE_KEY = "ticket_list_state";

  const getStoredListState = () => {
    try {
      const raw = sessionStorage.getItem(TICKET_LIST_STATE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      return null;
    }
  };

  const storedListState = getStoredListState();

  const [enabledFields, setEnabledFields] = useState([]);
  const [mandatoryFields, setMandatoryFields] = useState([]);
  const [fieldLabels, setFieldLabels] = useState({});

  const getEnabledField = async () => {
    try {
      const response = await getEnabledFieldApi();
      if (response?.success === true) {
        setEnabledFields(response?.enabled_fields ?? []);
        setMandatoryFields(response?.mandatory_fields ?? []);
        setFieldLabels(response?.application_labels ?? response?.labels ?? {});
      }
    } catch (err) {
      console.error("Error fetching enabled fields:", err);
    }
  };

  const isFieldEnabled = (field) => {
    if (field === "Title" || field === "Project") return true;
    if (field === "Customer" || field === "Client Name") {
      return enabledFields.some((item) => item === "Customer" || item === "Client Name");
    }
    return enabledFields.some((item) => item === field);
  };

  const isFieldMandatory = (field) => {
    if (field === "Title" || field === "Project") return true;
    if (!isFieldEnabled(field)) return false;
    if (field === "Customer" || field === "Client Name") {
      return mandatoryFields.some((item) => item === "Customer" || item === "Client Name");
    }
    return mandatoryFields.some((item) => item === field);
  };

  useEffect(() => {
    getEnabledField();
  }, []);

  const getFieldLabel = (fieldKey, defaultLabel) => {
    let custom = fieldLabels?.[fieldKey];
    if ((!custom || typeof custom !== "string" || custom.trim() === "") && (fieldKey === "Customer" || fieldKey === "Client Name")) {
      custom = fieldLabels?.["Customer"] || fieldLabels?.["Client Name"];
    }
    if (custom && typeof custom === "string" && custom.trim() !== "") {
      return custom.trim();
    }
    return defaultLabel;
  };

  const {
    filter_status,
    filter_create,
    filter_region,
    filter_location,
    filter_team,
    filter_customer,
    filter_vendor,
    filter_expt,
    listing_type,
    clearFilters,
  } = location.state || {};

  useEffect(() => {
    if (clearFilters) {
      sessionStorage.removeItem(TICKET_LIST_STATE_KEY);
      handleReset();
    }
  }, [clearFilters]);

  const [loading, setLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [ticketList, setListData] = useState([]);
  const [statusTicketList, setStatusTicketList] = useState([]);
  const [calendarTicketList, setCalendarTicketList] = useState([]);
  const [itemsPerPage, setItemsPerPage] = useState(
    Number(storedListState?.itemsPerPage) > 0
      ? Number(storedListState.itemsPerPage)
      : 10,
  );
  const [itemOffset, setItemOffset] = useState(
    Number(storedListState?.itemOffset) >= 0
      ? Number(storedListState.itemOffset)
      : 0,
  );
  const [pageCount, setPageCount] = useState(
    Number(storedListState?.pageCount) > 0
      ? Number(storedListState.pageCount)
      : 1,
  );
  const [calendarDateRange, setCalendarDateRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
  });
  const [range, setRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);
  const [selectedRange, setSelectedRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);

  const [startDate, setStartDate] = useState(() => {
    if (filter_expt != null && filter_expt !== "")
      return filter_expt.start_date;
    if (storedListState?.startDate)
      return moment(storedListState.startDate).toDate();
    return null;
  });
  const [endDate, setEndDate] = useState(() => {
    if (filter_expt != null && filter_expt !== "") return filter_expt.end_date;
    if (storedListState?.endDate)
      return moment(storedListState.endDate).toDate();
    return null;
  });
  const [selectedTicketList, setSelectedTicketList] = useState([]);

  const [inProgressList, setInProgressData] = useState([]);
  const [listingType, setListingType] = useState(() => {
    if (listing_type != null && listing_type !== "") {
      return listing_type;
    }
    if (storedListState?.listingType) {
      return storedListState.listingType;
    }
    return "assigned_me";
  });

  useEffect(() => {
    if (listing_type != null && listing_type !== "") {
      setListingType(listing_type);
      setItemOffset(0);
    }
  }, [listing_type, location.key]);

  const [view, setView] = useState(storedListState?.view || "table");
  const [showViewDropdown, setShowViewDropdown] = useState(false);
  const [showSortDropdown, setShowSortDropdown] = useState(false);
  const [sortBy, setSortBy] = useState(storedListState?.sortBy || "");
  const [sortOrder, setSortOrder] = useState(storedListState?.sortOrder || "");
  const [termApi, setTermApi] = useState(storedListState?.termApi || "");
  const [showSnackbar, setShowSnackbar] = useState(false);

  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [showBulkStatusUpdate, setShowBulkStatusUpdate] = useState(false);
  const [showBulkAssignUpdate, setShowBulkAssignUpdate] = useState(false);
  const [clearAllCheckbox, setClearAllCheckbox] = useState(false);

  const [countData, setCountData] = useState({
    assigned: 0,
    my_tickets: 0,
    closed: 0,
    assigned_to_team: 0,
    tickets: 0,
    created: 0,
    escalated: 0,
    total_estimation: 0,
  });
  const [todayCountData, setTodayCountData] = useState({
    created: 0,
    assigned: 0,
    escalated: 0,
    estimation: 0,
  });
  const [selectedHours, setSelectedHours] = useState({
    total_hours: 0,
    estimation_hours: 0,
    logged_hours: 0,
    manual_hours: 0,
  });
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  const [isHoveredTabs, setIsHoveredTabs] = useState(false);
  const scrollTabsRef = useRef(null);
  const prevFiltersRef = useRef({});

  const checkScroll = useCallback(() => {
    if (scrollTabsRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollTabsRef.current;
      setCanScrollLeft(scrollLeft > 0);
      setCanScrollRight(scrollLeft + clientWidth < scrollWidth - 1);
    }
  }, []);

  useEffect(() => {
    checkScroll();
    window.addEventListener("resize", checkScroll);
    return () => window.removeEventListener("resize", checkScroll);
  }, [checkScroll, countData, listingType]);

  const scrollTabs = (direction) => {
    if (scrollTabsRef.current) {
      const scrollAmount = 200;
      scrollTabsRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [selectedProjectOptions, setSelectedProjectOptions] = useState(() => {
    if (filter_create && filter_create.project) return [filter_create.project];
    return storedListState?.selectedProjectOptions || [];
  });
  const [selectedRegionOptions, setSelectedRegionOptions] = useState(() => {
    if (filter_region != null && filter_region !== "") return [filter_region];
    return storedListState?.selectedRegionOptions || [];
  });
  const [selectedLoctionOptions, setSelectedLoctionOptions] = useState(() => {
    if (filter_location != null && filter_location !== "")
      return [filter_location];
    return storedListState?.selectedLoctionOptions || [];
  });
  const [selectedTeamOptions, setSelectedTeamOptions] = useState(() => {
    if (filter_team != null && filter_team !== "") return [filter_team];
    return storedListState?.selectedTeamOptions || [];
  });
  const [selectedStatusOptions, setSelectedStatusOptions] = useState(() => {
    if (filter_status != null && filter_status !== "") return [filter_status];
    return storedListState?.selectedStatusOptions || [];
  });
  const [selectedComponentOptions, setSelectedComponentOptions] = useState(
    storedListState?.selectedComponentOptions || [],
  );
  const [selectedPriorityOptions, setSelectedPriorityOptions] = useState(
    storedListState?.selectedPriorityOptions || [],
  );
  const [selectedAssigneeOptions, setSelectedAssigneeOptions] = useState(
    storedListState?.selectedAssigneeOptions || [],
  );
  const [selectedReporterOptions, setSelectedReporterOptions] = useState(
    storedListState?.selectedReporterOptions || [],
  );
  const [selectedVendorOptions, setSelectedVendorOptions] = useState(() => {
    if (filter_vendor != null && filter_vendor !== "") return [filter_vendor];
    return storedListState?.selectedVendorOptions || [];
  });
  const [selectedCustomerOptions, setSelectedCustomerOptions] = useState(() => {
    if (filter_customer != null && filter_customer !== "")
      return [filter_customer];
    return storedListState?.selectedCustomerOptions || [];
  });
  const [selectedApprovalStatusOptions, setSelectedApprovalStatusOptions] =
    useState(storedListState?.selectedApprovalStatusOptions || []);
  const [selectedProjectOption, setProjectOption] = useState(null);
  const [selectedApprovalOption, setApprovalOption] = useState(null);
  const [selectedAssigneeStatusOption, setAssigneeStatusOption] = useState(
    storedListState?.selectedAssigneeStatusOption || null,
  );
  const [selectedComponentOption, setComponentOption] = useState(null);
  const [selectedAssigneeOption, setAssigneeOption] = useState(null);
  const [selectedReporterOption, setReporterOption] = useState(null);
  const [startDateCreated, setStartDateCreated] = useState(() => {
    if (
      filter_create != null &&
      filter_create !== "" &&
      filter_create.start_date
    )
      return filter_create.start_date;
    if (storedListState?.startDateCreated)
      return moment(storedListState.startDateCreated).toDate();
    return null;
  });
  const [endDateCreated, setEndDateCreated] = useState(() => {
    if (filter_create != null && filter_create !== "" && filter_create.end_date)
      return filter_create.end_date;
    if (storedListState?.endDateCreated)
      return moment(storedListState.endDateCreated).toDate();
    return null;
  });

  useEffect(() => {
    sessionStorage.setItem(
      TICKET_LIST_STATE_KEY,
      JSON.stringify({
        itemOffset,
        itemsPerPage,
        listingType,
        view,
        sortBy,
        sortOrder,
        termApi,
        startDate,
        endDate,
        startDateCreated,
        endDateCreated,
        selectedStatusOptions,
        selectedProjectOptions,
        selectedTeamOptions,
        selectedRegionOptions,
        selectedLoctionOptions,
        selectedComponentOptions,
        selectedPriorityOptions,
        selectedAssigneeOptions,
        selectedReporterOptions,
        selectedVendorOptions,
        selectedCustomerOptions,
        selectedApprovalStatusOptions,
        selectedAssigneeStatusOption,
        pageCount,
      }),
    );
  }, [
    itemOffset,
    itemsPerPage,
    listingType,
    view,
    sortBy,
    sortOrder,
    termApi,
    startDate,
    endDate,
    startDateCreated,
    endDateCreated,
    selectedStatusOptions,
    selectedProjectOptions,
    selectedTeamOptions,
    selectedRegionOptions,
    selectedLoctionOptions,
    selectedComponentOptions,
    selectedPriorityOptions,
    selectedAssigneeOptions,
    selectedReporterOptions,
    selectedVendorOptions,
    selectedCustomerOptions,
    selectedApprovalStatusOptions,
    selectedAssigneeStatusOption,
    pageCount,
  ]);

  useEffect(() => {
    const prev = prevFiltersRef.current;
    const current = {
      listingType,
      selectedStatusOptions,
      startDate,
      endDate,
      termApi,
      sortBy,
      sortOrder,
      selectedProjectOptions,
      selectedComponentOptions,
      selectedAssigneeOptions,
      selectedReporterOptions,
      selectedTeamOptions,
      selectedRegionOptions,
      selectedPriorityOptions,
      selectedLoctionOptions,
      selectedVendorOptions,
      selectedCustomerOptions,
      selectedApprovalStatusOptions,
      selectedAssigneeStatusOption,
      startDateCreated,
      endDateCreated,
    };

    const filtersChanged = Object.keys(current).some((key) => {
      if (prev[key] === undefined) return false;
      return JSON.stringify(prev[key]) !== JSON.stringify(current[key]);
    });

    if (filtersChanged && itemOffset !== 0) {
      setItemOffset(0);
    }

    prevFiltersRef.current = current;
  }, [
    listingType,
    selectedStatusOptions,
    startDate,
    endDate,
    termApi,
    sortBy,
    sortOrder,
    selectedProjectOptions,
    selectedComponentOptions,
    selectedAssigneeOptions,
    selectedReporterOptions,
    selectedTeamOptions,
    selectedRegionOptions,
    selectedPriorityOptions,
    selectedLoctionOptions,
    selectedVendorOptions,
    selectedCustomerOptions,
    selectedApprovalStatusOptions,
    selectedAssigneeStatusOption,
    startDateCreated,
    endDateCreated,
  ]);
  const [status, setStatus] = useState("All");
  const [showPicker, setShowPicker] = useState(false);

  const [showStatusUpdate, setShowStatusUpdate] = useState(false);
  const [updateStatus, setUpdateStatus] = useState(null);
  const [inProgressTicket, setInProgressTicket] = useState(null);
  const filterTypes = [
    {
      label: "Except description and comment",
      value: "except_description_and_comment",
    },
    { label: "Except Description", value: "except_description" },
    { label: "Except comment", value: "except_comment" },
    {
      label: "With description and Comment",
      value: "with_description_and_comment",
    },
  ];
  useEffect(() => {
    if (inProgressTicket !== null) {
      if (updateStatus === "In Progress") {
        handleDirectStatusUpdate(inProgressTicket, "In Progress");
      } else {
        setShowStatusUpdate(true);
      }
    }
  }, [inProgressTicket, updateStatus]);

  const handleDirectStatusUpdate = async (item, status) => {
    setLoading(true);
    try {
      const response = await apiCall("put", `ticket/status_update/${item.id}`, {
        status,
      });
      if (response?.status === 200 && response?.data?.success === true) {
        onSuccessStatusUpdate();
      } else {
        setSnackbarMessage(response?.data?.message ?? "Something went wrong");
        setSnackbarStatus(false);
        handleSnackbarShow();
      }
    } catch (err) {
      console.error("Error updating status:", err);
    } finally {
      setLoading(false);
      setInProgressTicket(null);
    }
  };
  /*   const ticketlist = Ticketapi();
    console.log('abcd');
    console.log(ticketList); */

  // Function to update values in the object
  // const updateCountData = async() => {
  //     try {
  //         const response = await axios.get(
  //             apiUrl+`ticket`,
  //             {
  //                 headers: {
  //                     "Content-Type": "application/json; charset=UTF-8",
  //                     Accept: "application/json",
  //                     "Access-Control-Allow-Origin": "*",
  //                     Authorization:
  //                         "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL2FwaS11YXQubWF3YWxvZy5jb20vYWRtaW4vdjIvYXBpL2xvZ2luIiwiaWF0IjoxNzM3OTU4OTc0LCJleHAiOjE3MzgwNDUzNzQsIm5iZiI6MTczNzk1ODk3NCwianRpIjoiQXgyZlFWUHp0SjhKOHE4NyIsInN1YiI6IjQyMSIsInBydiI6IjlhZDU4NTc3ZmFiNmZiYzE1NTQzNGQzNTkxZWRmMTY0YTE3NzY1YWEiLCJhdXRoaWQiOjQyMSwib3JnaWQiOjEwMCwidXNlcmlkIjo0MjEsImRhdGFiYXNlbmFtZSI6InJhZ3VyciIsIm9yZ19jb2RlIjoicmFndXJyIiwidGltZXpvbmUiOiIgKyBpbnRlcnZhbCAnMDUgaG91cnMgMzAgbWludXRlcyciLCJyb2xlaWQiOjQwMSwicGF5bWVudF9zdGF0dXMiOnRydWUsImF1dGhvcml0aWVzIjpbIlJPTEVfVVNFUiJdfQ.imDiJXJytfbRogqUu4ADrgANj8tpTObBoG_c0kom05w",
  //                 },
  //             }
  //         );

  //         setCountData({ assigned: 0, my_tickets: 0, closed: 0, assigned_to_team: 0 });
  //         setCountData({ assigned: response.data.tickets, my_tickets: 0, closed: 0, assigned_to_team: 0 });
  //     } catch (err) {
  //         console.error("Error fetching category:", err);
  //     } finally {
  //     }

  // };
  function checkPermission(permission) {
    return rolePermissionList.findIndex(
      (element) =>
        element["name"] === "Ticket" &&
        element["menu_permission"] === true &&
        element[permission] === true,
    ) > -1
      ? true
      : false;
  }
  function pagePermission(menuName) {
    const index = rolePermissionList.findIndex(
      (element) => element["name"] === menuName,
    );
    return index > -1 ? rolePermissionList[index] : {};
  }
  const [additionalPermissionList, setAdditionalPermissionList] = useState([]);

  function checkAdditionalPermission(menuName) {
    if (!checkPermission("additional_permission")) {
      return true;
    }
    return additionalPermissionList.findIndex(
      (element) =>
        element["name"] === menuName && element["permission"] === true,
    ) > -1
      ? true
      : false;
  }

  useEffect(() => {
    console.log("selectedCustomerOptions", selectedCustomerOptions);
    console.log("selectedProjectOptions", selectedProjectOptions);
    const index = rolePermissionList.findIndex(
      (element) => element["name"] === "Ticket",
    );
    if (index > -1) {
      setAdditionalPermissionList(
        rolePermissionList[index].additional_permissions_list,
      );
    }
    if (checkPermission("list_permission")) {
      getListData("");
      getListCount();
      getTodayCount();
      getInprogressList();
    }
  }, []);
  useEffect(() => {
    console.log("selectedProjectOptions", selectedProjectOptions);
    if (checkPermission("list_permission")) {
      if (view === "card") {
        getStatusTicketListing("");
      } else if (view === "calendar") {
        getCalendarTicketList("");
      } else {
        getListData("");
      }
      getInprogressList();
      getListCount();
      getTodayCount();
    }
  }, [
    listingType,
    selectedStatusOptions,
    itemsPerPage,
    itemOffset,
    startDate,
    endDate,
    termApi,
    sortBy,
    sortOrder,
    selectedProjectOptions,
    selectedComponentOptions,
    selectedAssigneeOptions,
    selectedReporterOptions,
    selectedTeamOptions,
    selectedRegionOptions,
    selectedPriorityOptions,
    selectedLoctionOptions,
    selectedVendorOptions,
    selectedCustomerOptions,
    selectedApprovalStatusOptions,
    selectedAssigneeStatusOption,
    startDateCreated,
    endDateCreated,
    location.key,
  ]);
  useEffect(() => {
    setClearAllCheckbox(true);
    setSelectedTicketList([]);
  }, [listingType, itemOffset]);

  useEffect(() => {
    if (selectedTicketList.length > 0) {
      getSelectedTicketHours();
    } else {
      setSelectedHours({
        total_hours: 0,
        estimation_hours: 0,
        logged_hours: 0,
        manual_hours: 0,
      });
    }
  }, [selectedTicketList]);
  useEffect(() => {
    if (checkPermission("list_permission")) {
      if (view === "card") {
        getStatusTicketListing("");
      } else if (view === "calendar") {
        getCalendarTicketList("");
      } else {
        getListData("");
      }
      if (view === "table") {
        getInprogressList();
      }
      /* if(view === "calendar"){
          getCalendarTicketList('');
        } */
    }
  }, [view]);
  const debounce = (func, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  const handleSearch = debounce(() => {
    if (view === "card") {
      getStatusTicketListing("");
    } else if (view === "calendar") {
      getCalendarTicketList("");
    } else {
      getListData("");
    }
  }, 1000);
  const statusBool = () => {
    if (status === "InActive") {
      return false;
    } else if (status === "Active") {
      return true;
    } else {
      return true;
    }
  };

  const getExcel = async (filterType) => {
    setExportLoading(true);
    try {
      const response = await apiCall("get", "ticket_template_data", null, {
        params: {
          limit: itemsPerPage,
          skip: itemOffset,
          type: listingType,
          assign_status:
            selectedAssigneeStatusOption != null
              ? selectedAssigneeStatusOption.value
              : "",
          approval_status: selectedApprovalStatusOptions
            .filter((item) => item.value !== "")
            .map((item) => item.value),
          from_date:
            startDate === null ? "" : commonFormatDate(startDate, "YYYY-MM-DD"),
          to_date:
            endDate === null ? "" : commonFormatDate(endDate, "YYYY-MM-DD"),
          status: selectedStatusOptions
            .filter((item) => item.value !== "")
            .map((item) => item.value),
          project_id: selectedProjectOptions
            .filter((item) => item.value !== "")
            .map((item) => item.value),
          component_id: selectedComponentOptions
            .filter((item) => item.value !== "")
            .map((item) => item.value),
          assignee: selectedAssigneeOptions
            .filter((item) => item.value !== "")
            .map((item) => item.value),
          reporter: selectedReporterOptions
            .filter((item) => item.value !== "")
            .map((item) => item.value),
          c_from_date:
            startDateCreated === null
              ? ""
              : commonFormatDate(startDateCreated, "YYYY-MM-DD"),
          c_to_date:
            endDateCreated === null
              ? ""
              : commonFormatDate(endDateCreated, "YYYY-MM-DD"),
          search: termApi,
          data_filter: filterType,
          id: selectedTicketList,
        },
      });

      if (response?.status === 200 && response.data?.success === true) {
        const base64String = response.data.base64;
        const fileName = "TicketList_" + new Date().getTime() + ".xlsx";
        const binary = atob(base64String);
        const array = [];
        for (let i = 0; i < binary.length; i++) {
          array.push(binary.charCodeAt(i));
        }
        const blob = new Blob([new Uint8Array(array)], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
      setSnackbarMessage(response?.data?.message ?? "Something went wrong");
      setSnackbarStatus(response?.data?.success === true);
      handleSnackbarShow();
    } catch (error) {
      setSnackbarMessage("Something went wrong");
      setSnackbarStatus(false);
      handleSnackbarShow();
    } finally {
      setExportLoading(false);
    }
  };
  const getListData = async (term) => {
    setLoading(true);
    console.log("getListData called with term:", selectedAssigneeStatusOption);
    // ?limit=10&skip=0&type=assigned_me&from_date=2025-01-01&to_date=2025-12-31
    // &search=&status=All&project=1&component=1&priority=
    // &reporter=1&assignee=1&search
    getListCount();
    try {
      const response = await apiCall("get", "ticket", null, {
        params: {
          limit: itemsPerPage,
          skip: itemOffset,
          type: listingType,
          assign_status:
            selectedAssigneeStatusOption != null
              ? selectedAssigneeStatusOption
              : "",
          approval_status: selectedApprovalStatusOptions
            .filter((item) => item.value !== "")
            .map((item) => item.value),
          from_date:
            startDate === null ? "" : commonFormatDate(startDate, "YYYY-MM-DD"),
          to_date:
            endDate === null ? "" : commonFormatDate(endDate, "YYYY-MM-DD"),
          search: termApi,
          status: selectedStatusOptions
            .filter((item) => item.value !== "")
            .map((item) => item.value),
          project_id: selectedProjectOptions
            .filter((item) => item.value !== "")
            .map((item) => item.value),
          component_id: selectedComponentOptions
            .filter((item) => item.value !== "")
            .map((item) => item.value),
          assignee: selectedAssigneeOptions
            .filter((item) => item.value !== "")
            .map((item) => item.value),
          reporter: selectedReporterOptions
            .filter((item) => item.value !== "")
            .map((item) => item.value),
          team_id: selectedTeamOptions
            .filter((item) => item.value !== "")
            .map((item) => item.value),
          region_id: selectedRegionOptions
            .filter((item) => item.value !== "")
            .map((item) => item.value),
          priority: selectedPriorityOptions
            .filter((item) => item.value !== "")
            .map((item) => item.value),
          location_id: selectedLoctionOptions
            .filter((item) => item.value !== "")
            .map((item) => item.value),
          vendor_id: selectedVendorOptions
            .filter((item) => item.value !== "")
            .map((item) => item.value),
          customer_id: selectedCustomerOptions
            .filter((item) => item.value !== "")
            .map((item) => item.value),
          c_from_date:
            startDateCreated === null
              ? ""
              : commonFormatDate(startDateCreated, "YYYY-MM-DD"),
          c_to_date:
            endDateCreated === null
              ? ""
              : commonFormatDate(endDateCreated, "YYYY-MM-DD"),
          sort_by: sortBy,
          sort_order: sortOrder,
        },
      });
      if (response?.status === 200 && response.data?.success === true) {
        const now = new Date();
        const ticketsWithTime = (response.data.tickets ?? []).map((ticket) => ({
          ...ticket,
          fetchedAt: now,
        }));
        setPageCount(response.data.total_pgs ?? 0);
        setListData(ticketsWithTime);
      } else {
        setListData([]);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setLoading(false);
    }
  };
  const getStatusTicketListing = async (term) => {
    setLoading(true);
    try {
      const response = await apiCall("get", "status_based_ticket", null, {
        params: {
          limit: itemsPerPage,
          skip: itemOffset,
          type: listingType,
          assign_status:
            selectedAssigneeStatusOption != null
              ? selectedAssigneeStatusOption
              : "",
          approval_status: selectedApprovalStatusOptions
            .filter((item) => item.value !== "")
            .map((item) => item.value),
          from_date:
            startDate === null ? "" : commonFormatDate(startDate, "YYYY-MM-DD"),
          to_date:
            endDate === null ? "" : commonFormatDate(endDate, "YYYY-MM-DD"),
          search: termApi,
          status: selectedStatusOptions
            .filter((item) => item.value !== "")
            .map((item) => item.value),
          project_id: selectedProjectOptions
            .filter((item) => item.value !== "")
            .map((item) => item.value),
          component_id: selectedComponentOptions
            .filter((item) => item.value !== "")
            .map((item) => item.value),
          assignee: selectedAssigneeOptions
            .filter((item) => item.value !== "")
            .map((item) => item.value),
          reporter: selectedReporterOptions
            .filter((item) => item.value !== "")
            .map((item) => item.value),
          c_from_date:
            startDateCreated === null
              ? ""
              : commonFormatDate(startDateCreated, "YYYY-MM-DD"),
          c_to_date:
            endDateCreated === null
              ? ""
              : commonFormatDate(endDateCreated, "YYYY-MM-DD"),
        },
      });
      if (response?.status === 200 && response.data?.success === true) {
        const now = new Date();
        const ticketsWithTime = (response.data.data ?? []).map((group) => ({
          ...group,
          fetchedAt: now,
          tickets: (group.tickets ?? []).map((ticket) => ({
            ...ticket,
            fetchedAt: now,
          })),
        }));
        setStatusTicketList(ticketsWithTime);
      } else {
        setStatusTicketList([]);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setLoading(false);
    }
  };
  const getListCount = async () => {
    try {
      const response = await apiCall("get", "get_ticket_count", null, {
        params: {
          limit: itemsPerPage,
          skip: itemOffset,
          type: listingType,
          assign_status:
            selectedAssigneeStatusOption != null
              ? selectedAssigneeStatusOption
              : "",
          approval_status: selectedApprovalStatusOptions
            .filter((item) => item.value !== "")
            .map((item) => item.value),
          from_date:
            startDate === null ? "" : commonFormatDate(startDate, "YYYY-MM-DD"),
          to_date:
            endDate === null ? "" : commonFormatDate(endDate, "YYYY-MM-DD"),
          search: termApi,
          status: selectedStatusOptions
            .filter((item) => item.value !== "")
            .map((item) => item.value),
          project_id: selectedProjectOptions
            .filter((item) => item.value !== "")
            .map((item) => item.value),
          component_id: selectedComponentOptions
            .filter((item) => item.value !== "")
            .map((item) => item.value),
          assignee: selectedAssigneeOptions
            .filter((item) => item.value !== "")
            .map((item) => item.value),
          reporter: selectedReporterOptions
            .filter((item) => item.value !== "")
            .map((item) => item.value),
          team_id: selectedTeamOptions
            .filter((item) => item.value !== "")
            .map((item) => item.value),
          region_id: selectedRegionOptions
            .filter((item) => item.value !== "")
            .map((item) => item.value),
          priority: selectedPriorityOptions
            .filter((item) => item.value !== "")
            .map((item) => item.value),
          location_id: selectedLoctionOptions
            .filter((item) => item.value !== "")
            .map((item) => item.value),
          vendor_id: selectedVendorOptions
            .filter((item) => item.value !== "")
            .map((item) => item.value),
          customer_id: selectedCustomerOptions
            .filter((item) => item.value !== "")
            .map((item) => item.value),
          c_from_date:
            startDateCreated === null
              ? ""
              : commonFormatDate(startDateCreated, "YYYY-MM-DD"),
          c_to_date:
            endDateCreated === null
              ? ""
              : commonFormatDate(endDateCreated, "YYYY-MM-DD"),
        },
      });
      if (response?.status === 200 && response.data?.success === true) {
        setCountData(response.data);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const getTodayCount = async () => {
    try {
      const response = await apiCall("get", "today_ticket_counts");
      if (response?.status === 200 && response.data?.success === true) {
        setTodayCountData(response.data.data);
      }
    } catch (err) {
      console.error("Error fetching today counts:", err);
    }
  };
  const getSelectedTicketHours = async () => {
    try {
      const response = await apiCall("post", "selected_ticket_hour", {
        ids: selectedTicketList,
      });
      if (response?.status === 200 && response.data?.success === true) {
        setSelectedHours(response.data.data);
      }
    } catch (err) {
      console.error("Error fetching selected ticket hours:", err);
    }
  };
  useEffect(() => {
    getCalendarTicketList("");
  }, [calendarDateRange]);

  function onChangeDateRange(dateRange) {
    setCalendarDateRange(dateRange);
  }
  const getCalendarTicketList = async (term) => {
    setLoading(true);

    try {
      const response = await apiCall("get", "ticket_calendar_list", null, {
        params: {
          /* limit:itemsPerPage,skip:itemOffset, */ type: listingType,
          assign_status:
            selectedAssigneeStatusOption != null
              ? selectedAssigneeStatusOption
              : "",
          approval_status: selectedApprovalStatusOptions
            .filter((item) => item.value !== "")
            .map((item) => item.value),
          from_date:
            startDate === null ? "" : commonFormatDate(startDate, "YYYY-MM-DD"),
          to_date:
            endDate === null ? "" : commonFormatDate(endDate, "YYYY-MM-DD"),
          search: termApi,
          status: selectedStatusOptions
            .filter((item) => item.value !== "")
            .map((item) => item.value),
          project_id: selectedProjectOptions
            .filter((item) => item.value !== "")
            .map((item) => item.value),
          component_id: selectedComponentOptions
            .filter((item) => item.value !== "")
            .map((item) => item.value),
          assignee: selectedAssigneeOptions
            .filter((item) => item.value !== "")
            .map((item) => item.value),
          reporter: selectedReporterOptions
            .filter((item) => item.value !== "")
            .map((item) => item.value),
          c_from_date:
            startDateCreated === null
              ? ""
              : commonFormatDate(startDateCreated, "YYYY-MM-DD"),
          c_to_date:
            endDateCreated === null
              ? ""
              : commonFormatDate(endDateCreated, "YYYY-MM-DD"),
        },
      });
      if (response?.status === 200 && response.data?.success === true) {
        const eventTemp = [];
        if (response.data.data != null && response.data.data.length > 0) {
          response.data?.data?.forEach((item) => {
            const date = moment(item["date"], "DD-MM-YYYY").toDate();
            item.tickets.forEach((ticket) => {
              eventTemp.push({
                title: ticket.title,
                color: "",
                duration: item["duration"] ?? "00:00",
                status: ticket.status,
                priority: ticket.priority,
                allDay: true,
                start: date,
                end: date,
                event_date: item["date"],
              });
            });
          });
        }
        setCalendarTicketList(eventTemp);
      } else {
        setCalendarTicketList([]);
      }
    } catch (err) {
      setCalendarTicketList([]);
      console.error("Error fetching options:", err);
    } finally {
      setLoading(false);
    }
  };
  const getInprogressList = async () => {
    try {
      const response = await apiCall("get", "get_inprogress_tickets");
      if (response?.status === 200 && response.data?.success === true) {
        const now = new Date();
        const ticketsWithTime = (response.data.tickets ?? []).map((ticket) => ({
          ...ticket,
          fetchedAt: now,
        }));
        setInProgressData(ticketsWithTime);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const endOffset = itemOffset + Number(itemsPerPage);
  console.log(`Loading items from ${itemOffset} to ${endOffset}`);
  //const currentItems = ticketList.slice(itemOffset, endOffset);
  /* const pageCount = Math.ceil(ticketList.length / itemsPerPage); */
  const handlePageClick = useCallback(
    (event) => {
      const newOffset = event.selected * Number(itemsPerPage);
      setItemOffset(newOffset);
      setClearAllCheckbox(true);
      setSelectedTicketList([]);
      if (location.state?.parentTicketId) {
        window.history.replaceState({}, document.title);
      }
    },
    [itemsPerPage, location.state],
  );
  /* const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % ticketList.length;
    console.log(
      `User requested page number ${event.selected}, which is offset ${newOffset}`
    );
    setItemOffset(event.selected);
  }; */
  const [deleteId, setDeleteId] = useState(null);
  const cloneTicket = async (ticket) => {
    setLoading(true);
    try {
      const response = await apiCall("get", `ticket/clone/${ticket.id}`);
      if (response?.status === 200 && response.data?.success === true) {
        const cloneData = response.data.ticket;
        // Inherit estimation if clone data returns 00:00 or empty
        if (
          (!cloneData.est || cloneData.est === "00:00") &&
          ticket.est &&
          ticket.est !== "00:00"
        ) {
          cloneData.est = ticket.est;
        }

        navigate("/ticket/add", {
          state: { id: null, cloneData: cloneData },
        });
      } else {
        setSnackbarMessage(response?.data?.message ?? "Failed to clone ticket");
        setSnackbarStatus(false);
        handleSnackbarShow();
      }
    } catch (err) {
      console.error("Error cloning ticket:", err);
    } finally {
      setLoading(false);
    }
  };

  const deleteTicket = async (id) => {
    setDeleteId(id);
    setIsOpenDelete(true);
  };
  const deleteTicketApi = async () => {
    if (deleteId != null) {
      const response = await apiCall("delete", `ticket/${deleteId}`);
      if (response?.status === 200 && response.data?.success === true) {
        setSelectedTicketList((prev) => prev.filter((id) => id !== deleteId));
        setDeleteId(null);
        setIsOpenDelete(false);
        getListData("");
        getListCount();
        getTodayCount();
        getInprogressList();
      }
      setSnackbarMessage(response?.data?.message ?? "Something went wrong");
      setSnackbarStatus(response?.data?.success === true);
      handleSnackbarShow();
    }
  };

  const modalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      opacity: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 2000,
    },
    modal: {
      backgroundColor: "#ffffff",
      padding: "40px",
      borderRadius: "16px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 1)",
      width: "436px",
      height: "228px",
      textAlign: "center",
    },
  };
  const alertRef = useRef(null);
  const alertDatePicRef = useRef(null);
  const viewDropdownRef = useRef(null);
  const sortDropdownRef = useRef(null);
  const sortOptions = [
    { label: "Title (A-Z)", value: "title", order: "asc" },
    { label: "Title (Z-A)", value: "title", order: "desc" },
    { label: "Created Date (Newest)", value: "created_date", order: "desc" },
    { label: "Created Date (Oldest)", value: "created_date", order: "asc" },
  ];
  const handleClickOutside = (event) => {
    if (alertRef.current && !alertRef.current.contains(event.target)) {
      setIsOpenDelete(false);
    }
    if (
      alertDatePicRef.current &&
      !alertDatePicRef.current.contains(event.target)
    ) {
      setShowPicker(false);
    }
    if (
      viewDropdownRef.current &&
      !viewDropdownRef.current.contains(event.target)
    ) {
      setShowViewDropdown(false);
    }
    if (
      sortDropdownRef.current &&
      !sortDropdownRef.current.contains(event.target)
    ) {
      setShowSortDropdown(false);
    }
  };
  useEffect(() => {
    // Attach event listener to the document
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Clean up event listener on unmount
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  function commonFormatDate(inputDate, formatString) {
    try {
      if (inputDate !== undefined) {
        /* // Parse the input date (MM/DD/YYYY format)
        const parsedDate = parse(inputDate, "MM/dd/yyyy", new Date());

        // Format the date
        return format(parsedDate, "EEEE, dd MMM yyyy");"dddd, DD MMM YYYY" */
        return moment(inputDate).format(formatString);
      } else {
        return "";
      }
    } catch (err) {
      console.error("Error fetching options:", err);
    } finally {
    }
  }
  const downloadTemplate = async () => {
    const response = await apiCall("get", "ticket_template_download");
    if (response?.status === 200 && response.data?.success === true) {
      const base64String = response.data.base64;
      const fileName = "Ticket_Template_" + new Date().getTime() + ".xlsx";
      const binary = atob(base64String);
      const array = [];
      for (let i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i));
      }
      const blob = new Blob([new Uint8Array(array)], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    setSnackbarMessage(response?.data?.message ?? "Something went wrong");
    setSnackbarStatus(response?.data?.success === true);
    handleSnackbarShow();
  };
  const fileInputRef = useRef(null);
  const handleFileClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    } else {
      console.error("File input is not initialized.");
    }
  };
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    console.log(file);
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        const base64String = reader.result; // this will be the byte code (base64String)
        console.log("Base64 String:", base64String.toString());
        uploadTicket(base64String);
        console.log(base64String); // You can view the byte code in the console
      };
      reader.readAsDataURL(file);
    } else {
      alert("Please select a valid excel file.");
    }
    fileInputRef.current.value = "";
  };
  const uploadTicket = async (base64String) => {
    //  setCustomSlotErrorMessage({date:'',  from:'',  to:'',});
    setLoading(true);
    try {
      const data = {
        file: base64String,
      };
      const response = await apiCall("post", "ticket_upload", data);
      setSnackbarMessage(response?.data?.message ?? "Something went wrong");
      setSnackbarStatus(response?.data?.success === true);
      handleSnackbarShow();
      if (response?.data?.base64) {
        const isSuccess = response?.data?.success === true;
        const fileName = isSuccess
          ? "Ticket_Upload_Success_" + new Date().getTime() + ".xlsx"
          : "Ticket_Upload_Error_" + new Date().getTime() + ".xlsx";
        const binary = atob(response.data.base64);
        const array = [];
        for (let i = 0; i < binary.length; i++) {
          array.push(binary.charCodeAt(i));
        }
        const blob = new Blob([new Uint8Array(array)], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (err) {
      console.error("Error fetching options:", err);
      /*  setError("Failed to fetch options. Try again."); */
    } finally {
      setLoading(false);
    }
  };
  // useEffect(() => {
  //   handleSearch();
  // }, [termApi]);

  const getFilterCount = () => {
    let count = 0;
    if (termApi !== "") count++;
    if (selectedStatusOptions.length > 0) count++;
    if (selectedProjectOptions.length > 0) count++;
    if (selectedRegionOptions.length > 0) count++;
    if (selectedLoctionOptions.length > 0) count++;
    if (selectedTeamOptions.length > 0) count++;
    if (selectedVendorOptions.length > 0) count++;
    if (selectedCustomerOptions.length > 0) count++;
    if (selectedComponentOptions.length > 0) count++;
    if (selectedPriorityOptions.length > 0) count++;
    if (selectedAssigneeOptions.length > 0) count++;
    if (selectedReporterOptions.length > 0) count++;
    if (selectedApprovalStatusOptions.length > 0) count++;
    if (startDateCreated !== null) count++;
    if (startDate !== null) count++;
    if (sortBy !== "") count++;
    if (
      selectedAssigneeStatusOption !== null &&
      selectedAssigneeStatusOption !== ""
    )
      count++;
    return count;
  };

  const filterWidget = () => {
    return (
      <div
        className="d-flex justify-content-between align-items-center flex-nowrap w-100 px-0"
        style={{ gap: "10px", overflow: "visible" }}
      >
        <div
          className="d-flex align-items-center flex-nowrap"
          onMouseEnter={() => setIsHoveredTabs(true)}
          onMouseLeave={() => setIsHoveredTabs(false)}
          style={{ gap: "4px", flex: "1", minWidth: 0, position: "relative" }}
        >
          {canScrollLeft && isHoveredTabs && (
            <div
              onClick={() => scrollTabs("left")}
              style={{
                position: "absolute",
                left: "1px",
                zIndex: 2,
                background:
                  "linear-gradient(to right, #FFFFFF 50%, rgba(255, 255, 255, 0))",
                height: "38px",
                width: "60px",
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                borderRadius: "11px 0 0 11px",
                pointerEvents: "auto",
              }}
            >
              <img
                src={lar}
                alt="left"
                style={{
                  width: "12px",
                  marginLeft: "10px",
                  filter:
                    "invert(26%) sepia(85%) saturate(3015%) hue-rotate(256deg) brightness(91%) contrast(97%)",
                }}
              />
            </div>
          )}

          <div
            ref={scrollTabsRef}
            onScroll={checkScroll}
            className="d-flex align-items-center flex-nowrap"
            style={{
              padding: "4px",
              background: "#FFFFFF",
              borderRadius: "12px",
              border: "1px solid #E5E5E5",
              height: "40px",
              overflowX: "auto",
              scrollbarWidth: "none",
              msOverflowStyle: "none",
              flex: "1",
              minWidth: 0,
              maxWidth: "fit-content",
            }}
          >
            <style>
              {`
                  div::-webkit-scrollbar {
                    display: none !important;
                  }
                `}
            </style>
            {checkAdditionalPermission("Assign-to-me-tab") && (
              <div
                onClick={() => {
                  setItemOffset(0);
                  setListingType("assigned_me");
                }}
                className={listingType === "assigned_me" ? "assi3" : "rest3"}
                style={{
                  borderRadius: listingType === "assigned_me" ? "8px" : "12px",
                  height: "32px",
                  display: "flex",
                  alignItems: "center",
                  whiteSpace: "nowrap",
                  flexShrink: 0,
                }}
              >
                <p
                  className={
                    listingType === "assigned_me" ? "passi3" : "prest3"
                  }
                  style={{
                    margin: 0,
                    fontWeight: "500",
                    fontSize: "14px",
                    whiteSpace: "nowrap",
                  }}
                >
                  Assigned{" "}
                  <span style={{ fontSize: "12px" }}>
                    ({countData.assigned ?? "0"})
                  </span>
                </p>
              </div>
            )}

            {checkAdditionalPermission("My-tickets-tab") && (
              <div
                onClick={() => {
                  setItemOffset(0);
                  setListingType("my_tickets");
                }}
                className={listingType === "my_tickets" ? "assi3" : "rest3"}
                style={{
                  borderRadius: listingType === "my_tickets" ? "8px" : "12px",
                  height: "32px",
                  display: "flex",
                  alignItems: "center",
                  whiteSpace: "nowrap",
                  flexShrink: 0,
                }}
              >
                <p
                  className={listingType === "my_tickets" ? "passi3" : "prest3"}
                  style={{
                    margin: 0,
                    fontWeight: "500",
                    fontSize: "14px",
                    whiteSpace: "nowrap",
                  }}
                >
                  My Tickets{" "}
                  <span style={{ fontSize: "12px" }}>
                    ({countData.my_tickets ?? "0"})
                  </span>
                </p>
              </div>
            )}

            {checkAdditionalPermission("Assign-to-my-team-tab") && (
              <div
                onClick={() => {
                  setItemOffset(0);
                  setListingType("assigned_to_team");
                }}
                className={
                  listingType === "assigned_to_team" ? "assi3" : "rest3"
                }
                style={{
                  borderRadius:
                    listingType === "assigned_to_team" ? "8px" : "12px",
                  height: "32px",
                  display: "flex",
                  alignItems: "center",
                  whiteSpace: "nowrap",
                  flexShrink: 0,
                }}
              >
                <p
                  className={
                    listingType === "assigned_to_team" ? "passi3" : "prest3"
                  }
                  style={{
                    margin: 0,
                    fontWeight: "500",
                    fontSize: "14px",
                    whiteSpace: "nowrap",
                  }}
                >
                  Team tickets{" "}
                  <span style={{ fontSize: "12px" }}>
                    ({countData.assigned_to_team ?? "0"})
                  </span>
                </p>
              </div>
            )}

            {checkAdditionalPermission("User-closed-tab") && (
              <div
                onClick={() => {
                  setItemOffset(0);
                  setListingType("closed");
                }}
                className={listingType === "closed" ? "assi3" : "rest3"}
                style={{
                  borderRadius: listingType === "closed" ? "8px" : "12px",
                  height: "32px",
                  display: "flex",
                  alignItems: "center",
                  whiteSpace: "nowrap",
                  flexShrink: 0,
                }}
              >
                <p
                  className={listingType === "closed" ? "passi3" : "prest3"}
                  style={{
                    margin: 0,
                    fontWeight: "500",
                    fontSize: "14px",
                    whiteSpace: "nowrap",
                  }}
                >
                  User closed{" "}
                  <span style={{ fontSize: "12px" }}>
                    ({countData.closed ?? "0"})
                  </span>
                </p>
              </div>
            )}
            {checkAdditionalPermission("Ticket-tab") && (
              <div
                onClick={() => {
                  setItemOffset(0);
                  setListingType("tickets");
                }}
                className={listingType === "tickets" ? "assi3" : "rest3"}
                style={{
                  borderRadius: listingType === "tickets" ? "8px" : "12px",
                  height: "32px",
                  display: "flex",
                  alignItems: "center",
                  whiteSpace: "nowrap",
                  flexShrink: 0,
                }}
              >
                <p
                  className={listingType === "tickets" ? "passi3" : "prest3"}
                  style={{
                    margin: 0,
                    fontWeight: "500",
                    fontSize: "14px",
                    whiteSpace: "nowrap",
                  }}
                >
                  Tickets{" "}
                  <span style={{ fontSize: "12px" }}>
                    ({countData.tickets ?? "0"})
                  </span>
                </p>
              </div>
            )}

            {checkAdditionalPermission("Approval-tab") && (
              <div
                onClick={() => {
                  setItemOffset(0);
                  setListingType("approval");
                }}
                className={listingType === "approval" ? "assi3" : "rest3"}
                style={{
                  borderRadius: listingType === "approval" ? "8px" : "12px",
                  height: "32px",
                  display: "flex",
                  alignItems: "center",
                  padding: "0 16px",
                  whiteSpace: "nowrap",
                  flexShrink: 0,
                }}
              >
                <p
                  className={listingType === "approval" ? "passi3" : "prest3"}
                  style={{
                    margin: 0,
                    fontWeight: "500",
                    fontSize: "14px",
                    whiteSpace: "nowrap",
                  }}
                >
                  Approval{" "}
                  <span style={{ fontSize: "12px" }}>
                    ({countData.approval ?? "0"})
                  </span>
                </p>
              </div>
            )}
          </div>

          {canScrollRight && isHoveredTabs && (
            <div
              onClick={() => scrollTabs("right")}
              style={{
                position: "absolute",
                right: "1px",
                zIndex: 2,
                background:
                  "linear-gradient(to left, #FFFFFF 50%, rgba(255, 255, 255, 0))",
                height: "38px",
                width: "60px",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                cursor: "pointer",
                borderRadius: "0 11px 11px 0",
                pointerEvents: "auto",
              }}
            >
              <img
                src={rar}
                alt="right"
                style={{
                  width: "12px",
                  marginRight: "10px",
                  filter:
                    "invert(26%) sepia(85%) saturate(3015%) hue-rotate(256deg) brightness(91%) contrast(97%)",
                }}
              />
            </div>
          )}
        </div>
        <div
          className="d-flex align-items-center flex-nowrap"
          style={{ gap: "10px", flexShrink: 0, marginLeft: "auto" }}
        >
          <div style={{ width: "120px", flexShrink: 0 }}>
            <MultiSelectDropDown
              staticOptions={statusList}
              onDropdownChange={handleStatusDropdownChange}
              apiUrl={""}
              placeholder={"All tickets"}
              selectedOption={selectedStatusOptions}
              placeholderColor="#6929E2"
              customHeaderStyle={{
                borderRadius: "12px",
                height: "40px",
                border: "1px solid #E5E5E5",
                fontWeight: "700",
                fontSize: "14px",
                padding: "0 16px",
                whiteSpace: "nowrap",
              }}
            />
          </div>

          <div
            ref={alertDatePicRef}
            style={{ height: "40px", flexShrink: 0, position: "relative" }}
          >
            {startDate === null && (
              <div
                onClick={() => setShowPicker(!showPicker)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  background: "#ffffff",
                  border: "1px solid #E5E5E5",
                  borderRadius: "12px",
                  padding: "0 16px",
                  cursor: "pointer",
                  height: "40px",
                  whiteSpace: "nowrap",
                }}
              >
                <img
                  src={calendarOutline}
                  alt="calendar"
                  style={{ width: "18px", marginRight: "8px" }}
                />
                <span
                  style={{
                    fontFamily: "Satoshi",
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#212129",
                    whiteSpace: "nowrap",
                  }}
                >
                  Exp. date
                </span>
              </div>
            )}
            {startDate != null && (
              <div
                onClick={() => setShowPicker(!showPicker)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  background: "#ffffff",
                  border: "1px solid #6929E2",
                  borderRadius: "12px",
                  padding: "0 16px",
                  height: "40px",
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                }}
              >
                <CalendarPurpleIcon
                  style={{ width: "16px", marginRight: "8px" }}
                />
                <span
                  style={{
                    fontFamily: "Satoshi",
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#6929E2",
                    whiteSpace: "nowrap",
                  }}
                >
                  {commonFormatDate(startDate, "DD MMM")} -{" "}
                  {commonFormatDate(endDate, "DD MMM")}
                </span>
                <CalendarClose
                  onClick={(e) => {
                    e.stopPropagation();
                    setRange([
                      {
                        startDate: new Date(),
                        endDate: new Date(),
                        key: "selection",
                      },
                    ]);
                    setStartDate(null);
                    setEndDate(null);
                  }}
                  style={{
                    cursor: "pointer",
                    color: "#6929E2",
                    marginLeft: "8px",
                  }}
                />
              </div>
            )}
            {showPicker && (
              <div
                style={{
                  position: "absolute",
                  top: "48px",
                  left: "0",
                  zIndex: 300,
                  background: "#fff",
                  border: "1px solid #ccc",
                  borderRadius: "12px",
                  boxShadow: "0px 4px 24px rgba(0,0,0,0.15)",
                }}
              >
                <DateRangePicker
                  ranges={range}
                  onChange={(item) => {
                    setStartDate(item.selection.startDate);
                    setEndDate(item.selection.endDate);
                    setRange([item.selection]);
                  }}
                  showSelectionPreview={true}
                  moveRangeOnFirstSelection={false}
                  months={1}
                  direction="horizontal"
                />
              </div>
            )}
          </div>
          <div
            className="d-flex align-items-center flex-nowrap"
            style={{ gap: "10px", flexShrink: 0 }}
          >
            <div
              style={{ position: "relative", width: "160px", flexShrink: 0 }}
            >
              <img
                src={lens}
                alt="search"
                style={{
                  position: "absolute",
                  left: "14px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  width: "16px",
                }}
              />
              <input
                type="text"
                placeholder="Search tasks..."
                className="txt3"
                style={{
                  width: "100%",
                  paddingLeft: "40px",
                  height: "40px",
                  borderRadius: "100px",
                  border: "1px solid #E5E5E5",
                }}
                value={termApi}
                onChange={(event) => setTermApi(event.target.value)}
              />
            </div>
            <div style={{ position: "relative", flexShrink: 0 }}>
              <div
                style={{
                  height: "40px",
                  borderRadius: "100px",
                  border: "1px solid #E5E5E5",
                  backgroundColor: "#FFFFFF",
                  display: "flex",
                  alignItems: "center",
                  padding: "0 14px",
                  cursor: "pointer",
                  gap: "8px",
                }}
                onClick={() => setIsFilterOpen(true)}
              >
                <img src={filter} alt="filter" style={{ width: "16px" }} />
                {getFilterCount() > 0 && (
                  <div
                    style={{
                      width: "24px",
                      height: "24px",
                      borderRadius: "50%",
                      backgroundColor: "#F3EDFF",
                      color: "#6929E2",
                      fontSize: "12px",
                      fontWeight: "700",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontFamily: "Satoshi",
                    }}
                  >
                    {getFilterCount()}
                  </div>
                )}
              </div>
              {getFilterCount() > 0 && (
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    handleReset();
                    getListCount();
                  }}
                  style={{
                    position: "absolute",
                    top: "-6px",
                    right: "-4px",
                    width: "22px",
                    height: "22px",
                    borderRadius: "50%",
                    backgroundColor: "#FF4444",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    border: "2px solid #FFFFFF",
                    zIndex: 10,
                  }}
                >
                  <img
                    src={close}
                    style={{
                      width: "8px",
                      height: "8px",
                      filter: "brightness(0) invert(1)",
                    }}
                    alt="Clear"
                  />
                </div>
              )}
            </div>
            <div
              ref={sortDropdownRef}
              style={{ position: "relative", flexShrink: 0 }}
            >
              <div
                onClick={() => setShowSortDropdown((prev) => !prev)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  background: "#ffffff",
                  border: sortBy ? "1px solid #6929E2" : "1px solid #E5E5E5",
                  borderRadius: "100px",
                  padding: "0 16px",
                  height: "40px",
                  cursor: "pointer",
                  gap: "8px",
                  whiteSpace: "nowrap",
                }}
              >
                <img src={arrows} alt="sort" style={{ width: "13px" }} />
                <span
                  style={{
                    fontFamily: "Satoshi",
                    fontSize: "14px",
                    fontWeight: "700",
                    color: sortBy ? "#6929E2" : "#212129",
                    whiteSpace: "nowrap",
                  }}
                >
                  {sortBy
                    ? sortOptions.find(
                        (opt) =>
                          opt.value === sortBy && opt.order === sortOrder,
                      )?.label
                    : "Sort"}
                  {!sortBy && (
                    <span style={{ fontWeight: "400", color: "#8790A1" }}>
                      {" "}
                      (Default)
                    </span>
                  )}
                </span>
                <img src={arrowDown} alt="arrow" style={{ width: "10px" }} />
              </div>
              {showSortDropdown && (
                <div
                  style={{
                    position: "absolute",
                    top: "48px",
                    right: "0",
                    background: "#FFFFFF",
                    borderRadius: "12px",
                    boxShadow: "0 4px 24px rgba(0,0,0,0.12)",
                    padding: "8px 4px",
                    zIndex: 200,
                    minWidth: "200px",
                  }}
                >
                  {sortOptions.map((item, idx) => (
                    <div
                      key={`${item.value}-${item.order}`}
                      onClick={() => {
                        if (sortBy === item.value && sortOrder === item.order) {
                          setSortBy("");
                          setSortOrder("");
                        } else {
                          setSortBy(item.value);
                          setSortOrder(item.order);
                        }
                        setShowSortDropdown(false);
                      }}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        gap: "10px",
                        borderRadius: "12px",
                        padding: "10px 12px",
                        cursor: "pointer",
                        background:
                          sortBy === item.value && sortOrder === item.order
                            ? "#F5F2FD"
                            : "transparent",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "14px",
                          fontWeight:
                            sortBy === item.value && sortOrder === item.order
                              ? "700"
                              : "500",
                          color:
                            sortBy === item.value && sortOrder === item.order
                              ? "#6929E2"
                              : "#212129",
                          fontFamily: "Satoshi",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {item.label}
                      </span>
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div
              ref={viewDropdownRef}
              style={{ position: "relative", flexShrink: 0 }}
            >
              <div
                onClick={() => setShowViewDropdown((prev) => !prev)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  background: "#ffffff",
                  border: "1px solid #E5E5E5",
                  borderRadius: "100px",
                  padding: "0 12px",
                  height: "40px",
                  cursor: "pointer",
                  gap: "8px",
                }}
              >
                <img
                  src={
                    view === "table"
                      ? tableActive
                      : view === "card"
                        ? cardActive
                        : view === "list"
                          ? listActive
                          : calendarActive
                  }
                  alt="view"
                  style={{
                    width: view === "calendar" ? "16px" : "14px",
                    height: view === "calendar" ? "16px" : "14px",
                  }}
                />
                <img src={arrowDown} alt="arrow" style={{ width: "10px" }} />
              </div>
              {showViewDropdown && (
                <div
                  style={{
                    position: "absolute",
                    top: "48px",
                    right: "0",
                    background: "#FFFFFF",
                    borderRadius: "12px",
                    boxShadow: "0 4px 24px rgba(0,0,0,0.12)",
                    padding: "8px 4px",
                    zIndex: 200,
                    minWidth: "160px",
                  }}
                >
                  {[
                    {
                      key: "table",
                      label: "Table",
                      icon: tableActive,
                      inactiveIcon: tableInActive,
                    },
                    {
                      key: "card",
                      label: "Kanban",
                      icon: cardActive,
                      inactiveIcon: cardInActive,
                    },
                    {
                      key: "list",
                      label: "Card",
                      icon: listActive,
                      inactiveIcon: listInActive,
                    },
                    {
                      key: "calendar",
                      label: "Calendar",
                      icon: calendarActive,
                      inactiveIcon: calendarInActive,
                    },
                  ].map((item) => (
                    <div
                      key={item.key}
                      onClick={() => {
                        setView(item.key);
                        setShowViewDropdown(false);
                      }}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        borderRadius: "12px",
                        padding: "10px 12px",
                        cursor: "pointer",
                        background:
                          view === item.key ? "#F5F2FD" : "transparent",
                      }}
                    >
                      <img
                        src={view === item.key ? item.icon : item.inactiveIcon}
                        alt={item.label}
                        style={{
                          width: item.key === "calendar" ? "16px" : "14px",
                          height: item.key === "calendar" ? "16px" : "14px",
                        }}
                      />
                      <span
                        style={{
                          fontSize: "16px",
                          fontWeight: view === item.key ? "700" : "500",
                          color: view === item.key ? "#6929E2" : "#212129",
                          fontFamily: "Satoshi",
                        }}
                      >
                        {item.label}
                      </span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };
  const handleViewRolePermission = (e) => {
    if (checkPermission("view_permission") === false) {
      e.preventDefault(); // Prevent navigation
    }
  };
  const [statusList, setStatusList] = useState([
    { label: "Open", value: "Open" },
    { label: "In Progress", value: "In Progress" },
    { label: "Hold", value: "Hold" },
    { label: "Closed", value: "Closed" },
    { label: "Completed", value: "Completed" },
  ]);
  const [priorityList, setPriorityList] = useState([
    { label: "Low", value: "Low" },
    { label: "Medium", value: "Medium" },
    { label: "High", value: "High" },
  ]);

  const handleProjectDropdownChange = (selectedOptions) => {
    console.log(selectedOptions);
    const index = selectedProjectOptions.findIndex(
      (option) => option.value === selectedOptions.value,
    );
    console.log("selectedProjectOptions", selectedProjectOptions);
    if (index > -1) {
      const updatedOptions = selectedProjectOptions.filter(
        (option) => option.value !== selectedOptions.value,
      );
      setSelectedProjectOptions(updatedOptions);
    } else {
      setSelectedProjectOptions([...selectedProjectOptions, selectedOptions]);
    }
  };

  const handleTeamDropdownChange = (selectedOptions) => {
    const index = selectedTeamOptions.findIndex(
      (option) => option.value === selectedOptions.value,
    );
    if (index > -1) {
      const updatedOptions = selectedTeamOptions.filter(
        (option) => option.value !== selectedOptions.value,
      );
      setSelectedTeamOptions(updatedOptions);
    } else {
      setSelectedTeamOptions([...selectedTeamOptions, selectedOptions]);
    }
  };
  const handleRegionDropdownChange = (selectedOptions) => {
    const index = selectedRegionOptions.findIndex(
      (option) => option.value === selectedOptions.value,
    );
    if (index > -1) {
      const updatedOptions = selectedRegionOptions.filter(
        (option) => option.value !== selectedOptions.value,
      );
      setSelectedRegionOptions(updatedOptions);
    } else {
      setSelectedRegionOptions([...selectedTeamOptions, selectedOptions]);
    }
  };
  const handleLocationDropdownChange = (selectedOptions) => {
    const index = selectedLoctionOptions.findIndex(
      (option) => option.value === selectedOptions.value,
    );
    if (index > -1) {
      const updatedOptions = selectedLoctionOptions.filter(
        (option) => option.value !== selectedOptions.value,
      );
      setSelectedLoctionOptions(updatedOptions);
    } else {
      setSelectedLoctionOptions([...selectedTeamOptions, selectedOptions]);
    }
  };

  const handleComponentDropdownChange = (selectedOptions) => {
    const index = selectedComponentOptions.findIndex(
      (option) => option.value === selectedOptions.value,
    );
    if (index > -1) {
      const updatedOptions = selectedComponentOptions.filter(
        (option) => option.value !== selectedOptions.value,
      );
      setSelectedComponentOptions(updatedOptions);
    } else {
      setSelectedComponentOptions([
        ...selectedComponentOptions,
        selectedOptions,
      ]);
    }
  };

  const handlePriorityDropdownChange = (selectedOptions) => {
    const index = selectedPriorityOptions.findIndex(
      (option) => option.value === selectedOptions.value,
    );
    if (index > -1) {
      const updatedOptions = selectedPriorityOptions.filter(
        (option) => option.value !== selectedOptions.value,
      );
      setSelectedPriorityOptions(updatedOptions);
    } else {
      setSelectedPriorityOptions([...selectedPriorityOptions, selectedOptions]);
    }
  };

  const handleAssigneeDropdownChange = (selectedOptions) => {
    const index = selectedAssigneeOptions.findIndex(
      (option) => option.value === selectedOptions.value,
    );
    if (index > -1) {
      const updatedOptions = selectedAssigneeOptions.filter(
        (option) => option.value !== selectedOptions.value,
      );
      setSelectedAssigneeOptions(updatedOptions);
    } else {
      setSelectedAssigneeOptions([...selectedAssigneeOptions, selectedOptions]);
    }
  };

  const handleReporterDropdownChange = (selectedOptions) => {
    const index = selectedReporterOptions.findIndex(
      (option) => option.value === selectedOptions.value,
    );
    if (index > -1) {
      const updatedOptions = selectedReporterOptions.filter(
        (option) => option.value !== selectedOptions.value,
      );
      setSelectedReporterOptions(updatedOptions);
    } else {
      setSelectedReporterOptions([...selectedReporterOptions, selectedOptions]);
    }
  };
  const handleVendorDropdownChange = (selectedOptions) => {
    const index = selectedVendorOptions.findIndex(
      (option) => option.value === selectedOptions.value,
    );
    if (index > -1) {
      const updatedOptions = selectedVendorOptions.filter(
        (option) => option.value !== selectedOptions.value,
      );
      setSelectedVendorOptions(updatedOptions);
    } else {
      setSelectedVendorOptions([...selectedVendorOptions, selectedOptions]);
    }
  };
  const handleCustomerDropdownChange = (selectedOptions) => {
    const index = selectedCustomerOptions.findIndex(
      (option) => option.value === selectedOptions.value,
    );
    if (index > -1) {
      const updatedOptions = selectedCustomerOptions.filter(
        (option) => option.value !== selectedOptions.value,
      );
      console.log(updatedOptions);
      setSelectedCustomerOptions(updatedOptions);
    } else {
      setSelectedCustomerOptions([...selectedCustomerOptions, selectedOptions]);
    }
  };

  const handleStatusDropdownChange = (selectedOptions) => {
    const index = selectedStatusOptions.findIndex(
      (option) => option.value === selectedOptions.value,
    );
    if (index > -1) {
      const updatedOptions = selectedStatusOptions.filter(
        (option) => option.value !== selectedOptions.value,
      );
      setSelectedStatusOptions(updatedOptions);
    } else {
      setSelectedStatusOptions([...selectedStatusOptions, selectedOptions]);
    }
  };
  const handleApprovalStatusDropdownChange = (selectedOptions) => {
    const index = selectedApprovalStatusOptions.findIndex(
      (option) => option.value === selectedOptions.value,
    );
    if (index > -1) {
      const updatedOptions = selectedApprovalStatusOptions.filter(
        (option) => option.value !== selectedOptions.value,
      );
      setSelectedApprovalStatusOptions(updatedOptions);
    } else {
      setSelectedApprovalStatusOptions([
        ...selectedApprovalStatusOptions,
        selectedOptions,
      ]);
    }
  };

  const handleDateChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };
  const handleCreatedDateChange = (dates) => {
    const [start, end] = dates;
    console.log(start, end);
    setStartDateCreated(start);
    setEndDateCreated(end);
  };
  const handleReset = () => {
    setSelectedProjectOptions([]);
    setSelectedCustomerOptions([]);
    setSelectedRegionOptions([]);
    setSelectedLoctionOptions([]);
    setSelectedTeamOptions([]);
    setSelectedVendorOptions([]);
    setSelectedComponentOptions([]);
    setSelectedPriorityOptions([]);
    setSelectedAssigneeOptions([]);
    setSelectedReporterOptions([]);
    setSelectedStatusOptions([]);
    setSelectedApprovalStatusOptions([]);
    setTermApi("");
    /*  setProjectOption(null);
    setComponentOption(null);
    setAssigneeOption(null);
    setReporterOption(null);
    setStatus(""); */
    setStartDate(null);
    setEndDate(null);
    setAssigneeStatusOption(null);
    setApprovalOption(null);
    setStartDateCreated(null);
    setEndDateCreated(null);
    setSortBy("");
    setSortOrder("");
    sessionStorage.removeItem(TICKET_LIST_STATE_KEY);
  };
  const assignedList = [
    { label: "Assigned", value: "assigned" },
    { label: "Unassigned", value: "un_assigned" },
  ];
  const approvalList = [
    { label: "Approved", value: "Approved" },
    { label: "Pending", value: "Pending" },
    { label: "Rejected", value: "Rejected" },
  ];
  const ticketStatusList = [
    { label: "All", value: "All" },
    { label: "Open", value: "Open" },
    { label: "In-Progress", value: "In-Progress" },
    { label: "Hold", value: "Hold" },
    { label: "Closed", value: "Closed" },
    { label: "Completed", value: "Completed" },
  ];
  const FilterPanel = ({ isOpen, onClose, onApply, initialFilters }) => {
    //filter css
    const styles = {
      container: {
        position: "fixed",
        top: 0,
        right: 0,
        transform: isOpen ? "translateX(0)" : "translateX(100%)",
        height: "100%",
        width: "400px",
        backgroundColor: "#F6F6F6",
        transition: "transform 0.3s ease-in-out",
        zIndex: 2000,
      },
      panel: {
        padding: "5px 14px 5px 14px",
      },
      header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "8px",
      },
      title: {
        fontSize: "18px",
        fontWeight: "700",
        color: "#212129",
      },
      closeIcon: {
        background: "#FFFFFF",
        border: "1px solid #EBEBEB",
        borderRadius: "100px",
        padding: "8px",
        height: "36px",
        width: "36px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
      },
      sectionTitle: {
        fontSize: "16px",
        fontWeight: "700",
        color: "#172B4D",
        marginBottom: "10px",
      },
      radioGroup: {
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        marginBottom: "11px",
      },
      radioLabel: (active) => ({
        display: "flex",
        alignItems: "center",
        gap: "8px",
        fontSize: "13px",
        fontFamily: "Epilogue",
        paddingTop: "8px",
        paddingBottom: "8px",
        fontWeight: 500,
        lineHeight: "100%",
        letterSpacing: "0%",
        verticalAlign: "middle",
        color: active ? "#D35258" : "#172B4D",
        cursor: "pointer",
      }),
      radioInput: (isActive) => ({
        width: "16px",
        height: "16px",
        border: "2px solid #D35258",
        borderRadius: "50%",
        background: isActive
          ? "radial-gradient(circle, #D35258 0%, #D35258 40%, transparent 41%)"
          : "#fff",
        cursor: "pointer",
        transition: "0.2s ease",
        display: "inline-block",
        appearance: "none",
        WebkitAppearance: "none",
        MozAppearance: "none",
        outline: "none",
      }),

      dateInput: {
        width: "100%",
        padding: "10px",
        height: "36px",
        borderRadius: "12px",
        border: "none",
        backgroundColor: "#FFE9EA",
        color: "#172B4D",
        fontSize: "13px",
        marginTop: "8px",
        outline: "none",
      },
      select: {
        width: "100%",
        height: "36px",
        padding: "10px",
        borderRadius: "12px",
        border: "1px solid #EBEBEB",
        fontSize: "13px",
        outline: "none",
      },
      modalFooter: {
        display: "flex",
        justifyContent: "space-between",
        marginTop: "20px",
      },
      resetButton: {
        padding: "10px 20px",
        border: "none",
        borderRadius: "100px",
        backgroundColor: "#f0f0f0",
        color: "#21272C",
        fontWeight: "bold",
        cursor: "pointer",
        fontSize: "13px",
      },
      applyButton: {
        padding: "10px 20px",
        border: "none",
        borderRadius: "100px",
        backgroundColor: "#6929E2",
        color: "#ffff",
        fontWeight: "bold",
        cursor: "pointer",
        fontSize: "13px",
      },
    };

    //filter modal
    return (
      <div>
        <style>{`
        .custom-datepicker {
          background-color: #ffffff !important;
          color: #172b4d !important;
          font-weight: 500 !important;
          font-size: 13px !important;
          cursor: pointer;
          height:40px;
        }

        .custom-datepicker::placeholder {
          color: #8790A1 !important;
          font-weight: 500;
          font-size: 13px;

        }

        .react-datepicker-wrapper{
          width:100% !important;
        }
      `}</style>
        <div
          className="container-fluid"
          style={{ ...styles.container, overflowY: "auto" }}
        >
          <div className="row" style={styles.panel}>
            <div className="col-12" style={styles.header}>
              <div style={styles.title}>Filters</div>
              <div style={styles.closeIcon} onClick={onClose}>
                <img
                  src={close}
                  alt="close"
                  style={{ width: "12px", height: "12px" }}
                />
              </div>
            </div>
            <div
              style={{
                borderRadius: "16px",
                padding: "12px",
                background: "#FFFFFF",
              }}
            >
              <div style={{ marginBottom: "10px" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "4px",
                  }}
                >
                  <div
                    style={{
                      fontWeight: "500",
                      fontSize: "12px",
                      color: "#172b4d",
                    }}
                  >
                    {getFieldLabel("Project", "Project")}
                  </div>
                  <div style={{ width: "100%" }}>
                    <div
                      style={{
                        width: "100%",
                        borderRadius: "8px",
                        fontWeight: "500",
                        fontSize: "12px",
                        color: "#172b4d",
                      }}
                    >
                      <MultiSelectDropDown
                        onDropdownChange={handleProjectDropdownChange}
                        apiUrl={`get_project`}
                        placeholder={getFieldLabel("Project", "Project")}
                        selectedOption={selectedProjectOptions}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ marginBottom: "10px" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "4px",
                  }}
                >
                  <div
                    style={{
                      fontWeight: "500",
                      fontSize: "12px",
                      color: "#172b4d",
                    }}
                  >
                    {getFieldLabel("Team", "Team")}
                  </div>
                  <div style={{ width: "100%" }}>
                    <div
                      style={{
                        width: "100%",
                        borderRadius: "8px",
                        fontWeight: "500",
                        fontSize: "12px",
                        color: "#172b4d",
                      }}
                    >
                      <MultiSelectDropDown
                        onDropdownChange={handleTeamDropdownChange}
                        apiUrl={`get_team`}
                        placeholder={getFieldLabel("Team", "Team")}
                        selectedOption={selectedTeamOptions}
                      />
                    </div>{" "}
                  </div>
                </div>
              </div>
              <div style={{ marginBottom: "10px" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "4px",
                  }}
                >
                  <div
                    style={{
                      fontWeight: "500",
                      fontSize: "12px",
                      color: "#172b4d",
                    }}
                  >
                    Region
                  </div>
                  <div style={{ width: "100%" }}>
                    <div
                      style={{
                        width: "100%",
                        borderRadius: "8px",
                        fontWeight: "500",
                        fontSize: "12px",
                        color: "#172b4d",
                      }}
                    >
                      <MultiSelectDropDown
                        onDropdownChange={handleRegionDropdownChange}
                        apiUrl={`region/autocomplete`}
                        placeholder={"Region"}
                        selectedOption={selectedRegionOptions}
                      />
                    </div>{" "}
                  </div>
                </div>
              </div>
              <div style={{ marginBottom: "10px" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "4px",
                  }}
                >
                  <div
                    style={{
                      fontWeight: "500",
                      fontSize: "12px",
                      color: "#172b4d",
                    }}
                  >
                    Location
                  </div>
                  <div style={{ width: "100%" }}>
                    <div
                      style={{
                        width: "100%",
                        borderRadius: "8px",
                        fontWeight: "500",
                        fontSize: "12px",
                        color: "#172b4d",
                      }}
                    >
                      <MultiSelectDropDown
                        onDropdownChange={handleLocationDropdownChange}
                        apiUrl={`get_location`}
                        placeholder={"Location"}
                        selectedOption={selectedLoctionOptions}
                      />
                    </div>{" "}
                  </div>
                </div>
              </div>
              <div style={{ marginBottom: "10px" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "4px",
                  }}
                >
                  <div
                    style={{
                      fontWeight: "500",
                      fontSize: "12px",
                      color: "#172b4d",
                    }}
                  >
                    {getFieldLabel("Level", "Component")}
                  </div>
                  <div style={{ width: "100%" }}>
                    <div
                      style={{
                        width: "100%",
                        borderRadius: "8px",
                        fontWeight: "500",
                        fontSize: "12px",
                        color: "#172b4d",
                      }}
                    >
                      <MultiSelectDropDown
                        onDropdownChange={handleComponentDropdownChange}
                        apiUrl={`get_component`}
                        placeholder={getFieldLabel("Level", "Component")}
                        selectedOption={selectedComponentOptions}
                      />
                    </div>{" "}
                  </div>
                </div>
              </div>

              <div style={{ marginBottom: "10px" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "4px",
                  }}
                >
                  <div
                    style={{
                      fontWeight: "500",
                      fontSize: "12px",
                      color: "#172b4d",
                    }}
                  >
                    {getFieldLabel("Assign To", "Assignee")}
                  </div>
                  <div style={{ width: "100%" }}>
                    <div
                      style={{
                        width: "100%",
                        borderRadius: "8px",
                        fontWeight: "500",
                        fontSize: "12px",
                        color: "#172b4d",
                      }}
                    >
                      <MultiSelectDropDown
                        onDropdownChange={handleAssigneeDropdownChange}
                        apiUrl={`get_employee`}
                        placeholder={getFieldLabel("Assign To", "Assignee")}
                        selectedOption={selectedAssigneeOptions}
                      />
                    </div>{" "}
                  </div>
                </div>
              </div>

              <div style={{ marginBottom: "10px" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "4px",
                  }}
                >
                  <div
                    style={{
                      fontWeight: "500",
                      fontSize: "12px",
                      color: "#172b4d",
                    }}
                  >
                    {getFieldLabel("Vendor", "Vendor")}
                  </div>
                  <div style={{ width: "100%" }}>
                    <div
                      style={{
                        width: "100%",
                        borderRadius: "8px",
                        fontWeight: "500",
                        fontSize: "12px",
                        color: "#172b4d",
                      }}
                    >
                      <MultiSelectDropDown
                        onDropdownChange={handleVendorDropdownChange}
                        apiUrl={`get_vendor`}
                        placeholder={getFieldLabel("Vendor", "Vendor")}
                        selectedOption={selectedVendorOptions}
                      />
                    </div>{" "}
                  </div>
                </div>
              </div>
              <div style={{ marginBottom: "10px" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "4px",
                  }}
                >
                  <div
                    style={{
                      fontWeight: "500",
                      fontSize: "12px",
                      color: "#172b4d",
                    }}
                  >
                    {getFieldLabel("Customer", "Customer")}
                  </div>
                  <div style={{ width: "100%" }}>
                    <div
                      style={{
                        width: "100%",
                        borderRadius: "8px",
                        fontWeight: "500",
                        fontSize: "12px",
                        color: "#172b4d",
                      }}
                    >
                      <MultiSelectDropDown
                        onDropdownChange={handleCustomerDropdownChange}
                        apiUrl={`get_client`}
                        placeholder={getFieldLabel("Customer", "Customer")}
                        selectedOption={selectedCustomerOptions}
                      />
                    </div>{" "}
                  </div>
                </div>
              </div>
              <div style={{ marginBottom: "10px" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "4px",
                  }}
                >
                  <div
                    style={{
                      fontWeight: "500",
                      fontSize: "12px",
                      color: "#172b4d",
                    }}
                  >
                    {getFieldLabel("Reporter", "Reporter")}
                  </div>
                  <div style={{ width: "100%" }}>
                    <div
                      style={{
                        width: "100%",
                        borderRadius: "8px",
                        fontWeight: "500",
                        fontSize: "12px",
                        color: "#172b4d",
                      }}
                    >
                      <MultiSelectDropDown
                        onDropdownChange={handleReporterDropdownChange}
                        apiUrl={`get_employee`}
                        placeholder={getFieldLabel("Reporter", "Reporter")}
                        selectedOption={selectedReporterOptions}
                      />
                    </div>{" "}
                  </div>
                </div>
              </div>
              <div style={{ marginBottom: "10px" }}>
                <h1
                  style={{
                    fontFamily: "Satoshi",
                    fontWeight: "500",
                    fontSize: "13px",
                    lineHeight: "17.55px",
                    color: "#212129",
                  }}
                >
                  {getFieldLabel("Priority", "Priority")}{" "}
                </h1>
                <MultiSelectDropDown
                  staticOptions={priorityList}
                  onDropdownChange={handlePriorityDropdownChange}
                  apiUrl={""}
                  placeholder={getFieldLabel("Priority", "Priority")}
                  selectedOption={selectedPriorityOptions}
                />
              </div>
              <div style={{ marginBottom: "10px" }}>
                <h1
                  style={{
                    fontFamily: "Satoshi",
                    fontWeight: "500",
                    fontSize: "13px",
                    lineHeight: "17.55px",
                    color: "#212129",
                  }}
                >
                  Ticket Status
                </h1>
                <MultiSelectDropDown
                  staticOptions={statusList}
                  onDropdownChange={handleStatusDropdownChange}
                  apiUrl={""}
                  placeholder={"Status"}
                  selectedOption={selectedStatusOptions}
                />
                {/* <select
                  className=""
                  id="assign_status"
                  value={status} // controlled
                  onChange={(e) => setStatus(e.target.value)}
                  style={{
                    width: "100%",
                    height: "40px",
                    fontFamily: "Satoshi",
                    fontSize: "14px",
                    fontWeight: "500",
                    lineHeight: "18.9px",
                    color: "#8790A1",
                    border: "0.7px solid #E5E5E5",
                    padding: "0 16px",
                    backgroundColor: "#FFFFFF",
                    borderRadius: "10px",
                  }}
                >
                  <option value="">Select</option>
                  {ticketStatusList.map((item, index) => (
                    <option key={index} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select> */}
              </div>

              <div style={{ marginBottom: "10px" }}>
                <h1
                  style={{
                    fontFamily: "Satoshi",
                    fontWeight: "500",
                    fontSize: "13px",
                    lineHeight: "17.55px",
                    color: "#212129",
                  }}
                >
                  Assigned Status
                </h1>

                <select
                  className=""
                  id="assign_status"
                  value={selectedAssigneeStatusOption} // controlled
                  onChange={(e) => setAssigneeStatusOption(e.target.value)}
                  style={{
                    width: "100%",
                    height: "40px",
                    fontFamily: "Satoshi",
                    fontSize: "14px",
                    fontWeight: "500",
                    lineHeight: "18.9px",
                    color: "#8790A1",
                    border: "0.7px solid #E5E5E5",
                    padding: "0 16px",
                    backgroundColor: "#FFFFFF",
                    borderRadius: "10px",
                  }}
                >
                  <option value="">Select</option>
                  {assignedList.map((item, index) => (
                    <option key={index} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>
              </div>
              <div style={{ marginBottom: "10px" }}>
                <h1
                  style={{
                    fontFamily: "Satoshi",
                    fontWeight: "500",
                    fontSize: "13px",
                    lineHeight: "17.55px",
                    color: "#212129",
                  }}
                >
                  Approval Status
                </h1>
                <MultiSelectDropDown
                  staticOptions={approvalList}
                  onDropdownChange={handleApprovalStatusDropdownChange}
                  apiUrl={""}
                  placeholder={"Approval Status"}
                  selectedOption={selectedApprovalStatusOptions}
                />
                {/* <select
                  className=""
                  id="approval_status"
                  value={selectedApprovalOption} // controlled
                  onChange={(e) => setApprovalOption(e.target.value)}
                  style={{
                    width: "100%",
                    height: "40px",
                    fontFamily: "Satoshi",
                    fontSize: "14px",
                    fontWeight: "500",
                    lineHeight: "18.9px",
                    color: "#8790A1",
                    border: "0.7px solid #E5E5E5",
                    padding: "0 16px",
                    backgroundColor: "#FFFFFF",
                    borderRadius: "10px",
                  }}
                >
                  <option value="">Select</option>
                  {approvalList.map((item, index) => (
                    <option key={index} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select> */}
              </div>
              {/* <div style={{ marginBottom: "10px" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "4px",
                  }}
                >
                  <div
                    style={{
                      fontWeight: "500",
                      fontSize: "12px",
                      color: "#172b4d",
                    }}
                  >
                    Expected Date
                  </div>
                  <div style={{ width: "100%" }}>
                    <div
                      style={{
                        borderRadius: "8px",
                        fontWeight: "500",
                        fontSize: "12px",
                        color: "#172b4d",
                      }}
                    >
                      <DatePicker
                        selected={startDate}
                        onChange={handleDateChange}
                        startDate={startDate}
                        endDate={endDate}
                        selectsRange
                        placeholderText="Select date range"
                        className="form-control rounded-3 custom-datepicker"
                        style={{
                          backgroundColor: "#F8F8F8",
                          color: "#8790A1",
                          cursor: "pointer",
                        }}
                      />
                    </div>{" "}
                  </div>
                </div>
              </div> */}

              <div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "4px",
                  }}
                >
                  <div
                    style={{
                      fontWeight: "500",
                      fontSize: "12px",
                      color: "#172b4d",
                    }}
                  >
                    Created Date
                  </div>
                  <div style={{ width: "100%" }}>
                    <div
                      style={{
                        borderRadius: "8px",
                        fontWeight: "500",
                        fontSize: "12px",
                        color: "#172b4d",
                      }}
                    >
                      <DatePicker
                        selected={startDateCreated}
                        onChange={handleCreatedDateChange}
                        startDate={startDateCreated}
                        endDate={endDateCreated}
                        selectsRange
                        placeholderText="Select date range"
                        className="form-control rounded-3 custom-datepicker"
                        style={{
                          backgroundColor: "#F8F8F8",
                          color: "#8790A1",
                          cursor: "pointer",
                        }}
                      />
                    </div>{" "}
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-12 mt-2 d-flex justify-content-end"
              style={styles.modalFooter}
            >
              <button
                className="btn btn-light me-2"
                style={styles.resetButton}
                onClick={() => {
                  handleReset();
                  setItemOffset(0);
                  if (view === "card") {
                    getStatusTicketListing("");
                  } else if (view === "calendar") {
                    getCalendarTicketList("");
                  } else {
                    getListData("");
                  }
                  if (view === "table") {
                    getInprogressList();
                  }
                  onClose();
                }}
              >
                Reset
              </button>
              <button
                className="btn btn-danger"
                style={styles.applyButton}
                onClick={() => {
                  if (view === "card") {
                    getStatusTicketListing("");
                  } else if (view === "calendar") {
                    getCalendarTicketList("");
                  } else {
                    getListData("");
                  }
                  if (view === "table") {
                    getInprogressList();
                  }
                  onClose();
                }}
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const onChangeTicketSelect = (list) => {
    setSelectedTicketList(list);
    setClearAllCheckbox(false);
  };
  function onSuccessStatus() {
    setClearAllCheckbox(true);
    setShowBulkStatusUpdate(false);
    setSnackbarMessage("Bulk status updated successfully!");
    setSnackbarStatus(true);
    handleSnackbarShow();
    getListData("");
    getInprogressList();
    getListCount();
    getTodayCount();
    if (selectedTicketList.length > 0) {
      getSelectedTicketHours();
    }
  }
  function onSuccessAssign() {
    setClearAllCheckbox(true);
    setShowBulkAssignUpdate(false);
    setSnackbarMessage("Bulk assign updated successfully!");
    setSnackbarStatus(true);
    handleSnackbarShow();
    getListData("");
    getListCount();
    getTodayCount();
    if (selectedTicketList.length > 0) {
      getSelectedTicketHours();
    }
  }
  function onSuccessStatusUpdate() {
    setShowStatusUpdate(false);
    setInProgressTicket(null);
    setSnackbarMessage("Status updated successfully!");
    setSnackbarStatus(true);
    handleSnackbarShow();
    getInprogressList();
    getListData("");
    getListCount();
    getTodayCount();
    if (selectedTicketList.length > 0) {
      getSelectedTicketHours();
    }
  }
  return (
    <Container
      fluid
      style={{ width: "100%", padding: "0px", overflowX: "hidden" }}
    >
      {showStatusUpdate && (
        <StatusUpdateModal
          ticketDetail={inProgressTicket}
          statusUpdate={updateStatus}
          success={onSuccessStatusUpdate}
          onHide={() => {
            setShowStatusUpdate(false);
            setInProgressTicket(null);
          }}
        />
      )}
      {showBulkStatusUpdate && (
        <BulkStatusUpdateModal
          ticketList={ticketList.filter(
            (item) =>
              selectedTicketList.includes(item.id) &&
              item.status !== "Closed" &&
              item.status !== "Completed",
          )}
          success={onSuccessStatus}
          onHide={() => {
            setShowBulkStatusUpdate(false);
          }}
        />
      )}
      {showBulkAssignUpdate && (
        <BulkAssignUpdateModal
          ticketList={ticketList
            .filter(
              (item) =>
                selectedTicketList.includes(item.id) &&
                item.status !== "Closed" &&
                item.status !== "Completed",
            )
            .map((item) => item.id)}
          success={onSuccessAssign}
          onHide={() => {
            setShowBulkAssignUpdate(false);
          }}
        />
      )}
      <div
        className="d-flex side4"
        style={{ width: "100%", overflowX: "hidden" }}
      >
        <Row
          sm={12}
          style={{
            "--bs-gutter-x": "0px",
            margin: "0px",
            width: "100%",
            //  height: "100vh",
            // overflow: "auto",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            justifyContent: "center",
          }}
        >
          <Col>
            <div className="maincontent3">
              {view === "table" && (
                // today Tickets
                <div
                  className="first3 d-flex align-items-center justify-content-between"
                  style={{
                    width: "100%",
                    height: "72px",
                    padding: "0 16px",
                    borderRadius: "16px",
                    backgroundColor: "#FFFFFF",
                  }}
                >
                  {/* Left Side: Title and Stats */}
                  <div
                    className="d-flex align-items-center h-100"
                    style={{ minWidth: 0, flex: 1 }}
                  >
                    <div
                      className="d-flex flex-column justify-content-center pe-2 pe-md-4"
                      style={{
                        minWidth: 0,
                        flexShrink: 1,
                        alignItems: "flex-start",
                        maxWidth: "100%",
                      }}
                    >
                      <span
                        className="tasks3"
                        style={{
                          fontSize: "20px",
                          fontWeight: "700",
                          color: "#1E1E1E",
                          fontFamily: "Satoshi",
                          lineHeight: "1",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: "100%",
                          display: "block",
                        }}
                      >
                        Tickets
                      </span>
                      <p
                        className="manage3"
                        style={{
                          fontSize: "14px",
                          fontWeight: "400",
                          color: "#8790A1",
                          margin: "4px 0 0 0",
                          fontFamily: "Satoshi",
                          lineHeight: "1",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: "100%",
                          display: "block",
                        }}
                      >
                        Manage your tasks seamlessly
                      </p>
                    </div>

                    <div
                      style={{
                        width: "1px",
                        height: "100%",
                        backgroundColor: "#E5E5E5",
                        flexShrink: 0,
                      }}
                    ></div>

                    <div
                      className="d-flex flex-column justify-content-center ps-2 ps-md-3 pe-2"
                      style={{
                        minWidth: 0,
                        flexShrink: 1,
                        alignItems: "flex-start",
                        maxWidth: "100%",
                      }}
                    >
                      <span
                        className="stats-title"
                        style={{
                          fontSize: "11px",
                          fontWeight: "500",
                          color: "#212129",
                          marginBottom: "4px",
                          fontFamily: "Satoshi",
                          lineHeight: "1",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: "100%",
                          display: "block",
                        }}
                      >
                        Today's Tasks
                      </span>
                      <div
                        className="stats-container d-flex align-items-center"
                        style={{
                          height: "32px",
                          background: "#f5f2fd",
                          borderRadius: "100px",
                          padding: "0 12px",
                          gap: "8px",
                          minWidth: 0,
                          maxWidth: "100%",
                        }}
                      >
                        <div
                          className="stat-item d-flex align-items-center gap-1 gap-md-2"
                          style={{ minWidth: 0 }}
                        >
                          <span
                            className="stat-label"
                            style={{
                              fontSize: "12px",
                              color: "#52525b",
                              fontFamily: "Satoshi",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              display: "block",
                            }}
                          >
                            Created
                          </span>
                          <span
                            className="stat-value"
                            style={{
                              fontSize: "14px",
                              fontWeight: "700",
                              color: "#212129",
                              fontFamily: "Satoshi",
                              flexShrink: 0,
                            }}
                          >
                            {todayCountData?.created ?? "0"}
                          </span>
                        </div>
                        <div
                          className="stat-divider"
                          style={{
                            width: "1px",
                            height: "100%",
                            backgroundColor: "#D6C0FF",
                            flexShrink: 0,
                          }}
                        ></div>
                        <div
                          className="stat-item d-flex align-items-center gap-1 gap-md-2"
                          style={{ minWidth: 0 }}
                        >
                          <span
                            className="stat-label"
                            style={{
                              fontSize: "12px",
                              color: "#52525b",
                              fontFamily: "Satoshi",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              display: "block",
                            }}
                          >
                            Assigned
                          </span>
                          <span
                            className="stat-value"
                            style={{
                              fontSize: "14px",
                              fontWeight: "700",
                              color: "#212129",
                              fontFamily: "Satoshi",
                              flexShrink: 0,
                            }}
                          >
                            {todayCountData?.assigned ?? "0"}
                          </span>
                        </div>
                        <div
                          className="stat-divider"
                          style={{
                            width: "1px",
                            height: "100%",
                            backgroundColor: "#D6C0FF",
                            flexShrink: 0,
                          }}
                        ></div>
                        <div
                          className="stat-item d-flex align-items-center gap-1 gap-md-2"
                          style={{ minWidth: 0 }}
                        >
                          <span
                            className="stat-label"
                            style={{
                              fontSize: "12px",
                              color: "#52525b",
                              fontFamily: "Satoshi",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              display: "block",
                            }}
                          >
                            Escalated
                          </span>
                          <span
                            className="stat-value"
                            style={{
                              fontSize: "14px",
                              fontWeight: "700",
                              color: "#212129",
                              fontFamily: "Satoshi",
                              flexShrink: 0,
                            }}
                          >
                            {todayCountData?.escalated ?? "0"}
                          </span>
                        </div>
                        <div
                          className="stat-divider"
                          style={{
                            width: "1px",
                            height: "100%",
                            backgroundColor: "#D6C0FF",
                            flexShrink: 0,
                          }}
                        ></div>
                        <div
                          className="stat-item d-flex align-items-center gap-1 gap-md-2"
                          style={{ minWidth: 0, flexShrink: 0 }}
                        >
                          <span
                            className="stat-label d-none d-lg-block"
                            style={{
                              fontSize: "12px",
                              color: "#52525b",
                              fontFamily: "Satoshi",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              display: "block",
                            }}
                          >
                            Estimation
                          </span>
                          <div className="d-flex align-items-baseline">
                            <span
                              className="stat-value purple"
                              style={{
                                fontSize: "14px",
                                fontWeight: "700",
                                color: "#6929e2",
                                fontFamily: "Satoshi",
                              }}
                            >
                              {todayCountData?.estimation ?? "0"}
                            </span>
                            <span
                              className="stat-unit"
                              style={{
                                fontSize: "12px",
                                fontWeight: "400",
                                color: "#6929e2",
                                marginLeft: "4px",
                                fontFamily: "Satoshi",
                              }}
                            >
                              hrs
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Right Side: Buttons */}
                  <div className="d-flex align-items-center h-100">
                    <div
                      style={{
                        width: "1px",
                        height: "100%",
                        backgroundColor: "#E5E5E5",
                      }}
                    ></div>
                    <div className="d-flex align-items-center gap-2 ps-2 ps-md-3">
                      {checkAdditionalPermission("Excel upload") && (
                        <div
                          onClick={() => loading == false && handleFileClick()}
                          className="action-btn-white"
                          style={{
                            height: "36px",
                            borderRadius: "100px",
                            border: "1px solid #E5E5E5",
                            padding: "0 12px",
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                            cursor: "pointer",
                            background: "#FFFFFF",
                          }}
                        >
                          <img
                            src={uploadIcon}
                            style={{ width: "16px" }}
                            alt="Excel"
                          />
                          <span
                            style={{
                              fontSize: "13px",
                              fontWeight: "700",
                              color: "#212129",
                              fontFamily: "Satoshi",
                            }}
                          >
                            Excel
                          </span>
                        </div>
                      )}
                      <input
                        ref={fileInputRef}
                        type="file"
                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        onChange={handleFileChange}
                        style={{ display: "none" }}
                      />

                      {checkAdditionalPermission("Excel upload") && (
                        <div
                          onClick={() => downloadTemplate()}
                          className="action-btn-white"
                          style={{
                            height: "36px",
                            borderRadius: "100px",
                            border: "1px solid #E5E5E5",
                            padding: "0 12px",
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                            cursor: "pointer",
                            background: "#FFFFFF",
                          }}
                        >
                          <img
                            src={downloadIcon}
                            style={{ width: "16px" }}
                            alt="Template"
                          />
                          <span
                            style={{
                              fontSize: "13px",
                              fontWeight: "700",
                              color: "#212129",
                              fontFamily: "Satoshi",
                            }}
                          >
                            Template
                          </span>
                        </div>
                      )}

                      <div
                        className="d-flex align-items-center"
                        style={{
                          background: "#6929E2",
                          borderRadius: "100px",
                          height: "36px",
                        }}
                      >
                        <div
                          onClick={() => !exportLoading && getExcel("")}
                          style={{
                            cursor: exportLoading ? "not-allowed" : "pointer",
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                            padding: "0 12px",
                            height: "100%",
                            opacity: exportLoading ? 1 : 1,
                          }}
                        >
                          {exportLoading ? (
                            <Spinner
                              animation="border"
                              size="sm"
                              variant="light"
                            />
                          ) : (
                            <img
                              src={downloadIcon}
                              style={{
                                width: "16px",
                                filter: "brightness(0) invert(1)",
                              }}
                              alt="Export"
                            />
                          )}
                          <span
                            style={{
                              fontSize: "13px",
                              fontWeight: "700",
                              color: "#FFFFFF",
                              fontFamily: "Satoshi",
                            }}
                          >
                            Export
                          </span>
                        </div>
                        <div
                          style={{
                            width: "1px",
                            height: "20px",
                            background: "rgba(255,255,255,0.4)",
                          }}
                        ></div>
                        <Dropdown className="export-dropdown">
                          <Dropdown.Toggle
                            id="dropdown-basic"
                            style={{
                              background: "transparent",
                              border: "none",
                              padding: "0 8px 0 6px",
                              height: "36px",
                              display: "flex",
                              alignItems: "center",
                              boxShadow: "none",
                              outline: "none",
                              cursor: "pointer",
                            }}
                          >
                            <img
                              src={arrowDown}
                              style={{
                                width: "10px",
                                filter: "brightness(0) invert(1)",
                              }}
                              alt="arrow"
                            />
                          </Dropdown.Toggle>
                          <Dropdown.Menu
                            style={{
                              borderRadius: "12px",
                              padding: "8px",
                              border: "1px solid #E5E5E5",
                              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                            }}
                          >
                            {filterTypes.map((item) => (
                              <Dropdown.Item
                                key={item.value}
                                onClick={() => getExcel(item.value)}
                                style={{
                                  borderRadius: "8px",
                                  fontSize: "13px",
                                  padding: "8px 12px",
                                }}
                              >
                                {item.label ?? ""}
                              </Dropdown.Item>
                            ))}
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {filterWidget()}
            </div>

            <div
              style={{
                width: "100%",
                maxWidth: "100%",
                overflow: "visible",
                minHeight: "450px",
              }}
            >
              {view === "table" && (
                <div style={{ height: "100%" }}>
                  {checkAdditionalPermission("In Progress") && (
                    <div
                      style={{
                        margin: "12px",
                        padding: "0px",
                        maxHeight: "70px",
                        overflowY: "auto",
                      }}
                    >
                      {inProgressList.map((item, index) => {
                        const [time, milliseconds] =
                          item.duration != null ? item.duration.split(".") : [];
                        return (
                          <div
                            key={"in-pro" + item.id}
                            className="third3 d-flex justify-content-between"
                            onClick={(e) => {
                              if (
                                checkPermission("view_permission") === false
                              ) {
                                e.preventDefault(); // Prevent navigation
                              } else {
                                navigate(`/ticket/view/${item.id}`);
                              }
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            <div>
                              <div className="taslog3">
                                <span className="tas3">
                                  <span
                                    title={item.title}
                                    style={{
                                      display: "inline-block",
                                      maxWidth: "350px",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap",
                                      verticalAlign: "bottom",
                                    }}
                                  >
                                    {item.title}
                                  </span>
                                  {item.is_sub === true && (
                                    <img
                                      src={subTicketIcon}
                                      style={{
                                        width: "16px",
                                        height: "16px",
                                        marginLeft: "8px",
                                        marginTop: "-5px",
                                      }}
                                    />
                                  )}
                                </span>
                              </div>
                              <div className="d-flex lst3">
                                <div className="est3">{getFieldLabel("Estimation", "Estimation")} :</div>
                                <div className="tim3">
                                  {item.est ?? "00:00"}{" "}
                                </div>
                              </div>
                            </div>

                            <div>
                              <div className="d-flex part333">
                                <div className="d-flex part33">
                                  <img
                                    src={rectangle}
                                    className="rect3"
                                    alt="inprogress"
                                  />
                                  <div className="inp3">In Progress</div>
                                  <div className="on3">|</div>
                                  {/*  { formatTime(inProgressList[index].seconds_elapsed!=undefined?inProgressList[index].seconds_elapsed:10)} */}
                                  {/* <p className="timm3">{time ?? "00:00"} hrs</p> */}
                                  {item.duration != null && (
                                    <Timer
                                      key={"inprogress-timer" + item.id}
                                      initialSeconds={parseDuration(time)}
                                    />
                                  )}
                                </div>

                                <div
                                  style={{
                                    width: "1px",
                                    height: "58px",
                                    backgroundColor: "#E5E5E5",
                                    marginLeft: "16px",
                                  }}
                                ></div>

                                <div className="d-flex vw3">
                                  {checkAdditionalPermission("Status update") &&
                                    item.sub_ticket_status === "Closed" &&
                                    item.status === "In Progress" && (
                                      <div
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setInProgressTicket(item);
                                          /* setIsOpenHold(true);
                              setIsOpenStatusUpdate(true);
                              setExpectedDate(moment(new Date()).format("YYYY-MM-DD")); */
                                          setUpdateStatus("Hold");
                                          /* setShowStatusUpdate(true); */
                                        }}
                                        className="ms-1 me-1"
                                        style={{
                                          cursor: "pointer",
                                          height: "36px",
                                          borderRadius: "100px",
                                          border: "1px solid #6929E2",
                                          padding: "8px 16px 8px 16px",
                                          gap: "8px",
                                          backgroundColor: "#ffffff",
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                        }}
                                      >
                                        <span
                                          style={{
                                            margin: "0",
                                            fontFamily: "Satoshi",
                                            fontWeight: "500",
                                            fontSize: "14px",
                                            lineHeight: "18.9px",
                                            color: "#6929E2",
                                          }}
                                        >
                                          Hold
                                        </span>
                                      </div>
                                    )}
                                  {checkAdditionalPermission("Status update") &&
                                    /* item.sub_ticket_status ==="Closed" && */ item.status ===
                                      "In Progress" && (
                                      <div
                                        onClick={async (e) => {
                                          e.stopPropagation();
                                          try {
                                            const response = await apiCall(
                                              "get",
                                              `ticket/edit/${item.id}`,
                                            );
                                            if (
                                              response?.status === 200 &&
                                              response.data?.success === true
                                            ) {
                                              const detail =
                                                response.data.ticket;
                                              let currentEnabled = enabledFields;
                                              let currentMandatory = mandatoryFields;
                                              if (
                                                currentEnabled.length === 0 &&
                                                currentMandatory.length === 0
                                              ) {
                                                const configRes =
                                                  await getEnabledFieldApi();
                                                if (configRes?.success) {
                                                  currentEnabled =
                                                    configRes.enabled_fields ??
                                                    [];
                                                  currentMandatory =
                                                    configRes.mandatory_fields ??
                                                    [];
                                                  setEnabledFields(
                                                    currentEnabled
                                                  );
                                                  setMandatoryFields(
                                                    currentMandatory
                                                  );
                                                }
                                              }
                                              const checkEnabled = (f) =>
                                                f === "Title" ||
                                                f === "Project" ||
                                                (f === "Customer" || f === "Client Name"
                                                  ? currentEnabled.includes("Customer") || currentEnabled.includes("Client Name")
                                                  : currentEnabled.includes(f));
                                              const checkMandatory = (f) =>
                                                (f === "Title" ||
                                                f === "Project" ||
                                                (f === "Customer" || f === "Client Name"
                                                  ? currentMandatory.includes("Customer") || currentMandatory.includes("Client Name")
                                                  : currentMandatory.includes(f))) &&
                                                checkEnabled(f);

                                              const errors = {};
                                              if (!detail.project_id)
                                                errors.project_id = [
                                                  "Update project to close ticket",
                                                ];
                                              if (
                                                checkEnabled("Level") &&
                                                checkMandatory("Level") &&
                                                !detail.component_id
                                              )
                                                errors.component_id = [
                                                  "Update level(component) to close ticket",
                                                ];
                                              if (
                                                checkMandatory("Assign To") &&
                                                !detail.assignee_id
                                              )
                                                errors.assignee = [
                                                  "Update assignee to close ticket",
                                                ];
                                              if (
                                                checkMandatory(
                                                  "Expected Date"
                                                ) &&
                                                !detail.expected
                                              )
                                                errors.expected_date = [
                                                  "Update expected date to close ticket",
                                                ];

                                              if (
                                                Object.keys(errors).length > 0
                                              ) {
                                                navigate("/ticket/add", {
                                                  state: {
                                                    id: detail.id,
                                                    rolePermission:
                                                      pagePermission("Ticket"),
                                                    errors,
                                                  },
                                                });
                                              } else {
                                                setInProgressTicket({
                                                  ...item,
                                                  ...detail,
                                                });
                                                setUpdateStatus("Closed");
                                              }
                                            }
                                          } catch (err) {
                                            console.error(
                                              "Error fetching ticket details:",
                                              err,
                                            );
                                          }
                                        }}
                                        className="me-1"
                                        style={{
                                          cursor: "pointer",
                                          height: "36px",
                                          borderRadius: "100px",
                                          border: "0.6px solid #E5E5E5",
                                          padding: "10px 28px 10px 28px",
                                          gap: "10px",
                                          backgroundColor: "#3253EB",
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                        }}
                                      >
                                        <p
                                          style={{
                                            fontFamily: "Satoshi",
                                            fontSize: "12px",
                                            fontWeight: "600",
                                            lineHeight: "18.9px",
                                            margin: "0",
                                            color: "#FFFFFF",
                                          }}
                                        >
                                          Close
                                        </p>
                                      </div>
                                    )}

                                  {/* <Link
                                to="/ticket/view"
                                onClick={handleViewRolePermission}
                                state={{ id: item.id }}
                                className="link23"
                              >
                                <p className="view3">View details</p>
                              </Link>
                              <Link
                                to="/ticket/view"
                                onClick={handleViewRolePermission}
                                state={{ id: item.id }}
                                className="link23"
                              >
                                <img src={arrows} className="arrows3" />
                              </Link> */}
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                  {selectedTicketList.length > 0 && (
                    <div
                      className="mx-2 my-2 d-flex flex-column"
                      style={{ gap: "10px" }}
                    >
                      <div
                        className="d-flex align-items-center flex-nowrap"
                        style={{
                          gap: "10px",
                          overflowX: "auto",
                          scrollbarWidth: "none",
                        }}
                      >
                        {[
                          {
                            label: "Total Hours",
                            value: selectedHours.total_hours,
                            color: "#6929E2",
                          },
                          {
                            label: "Estimation Hours",
                            value: selectedHours.estimation_hours,
                            color: "#FFB800",
                          },
                          {
                            label: "Logged Hours",
                            value: selectedHours.logged_hours,
                            color: "#3253EB",
                          },
                          {
                            label: "Manual Hours",
                            value: selectedHours.manual_hours,
                            color: "#2EAD77",
                          },
                        ].map((card, idx) => (
                          <div
                            key={idx}
                            className="flex-grow-1"
                            style={{
                              background: "#FFFFFF",
                              borderRadius: "16px",
                              padding: "0 24px 0 0",
                              display: "flex",
                              alignItems: "center",
                              border: "1px solid #F5F5F5",
                              minWidth: "240px",
                              height: "50px",
                              overflow: "hidden",
                            }}
                          >
                            <div
                              style={{
                                width: "4px",
                                height: "32px",
                                background: card.color,
                                borderRadius: "0 100px 100px 0",
                                flexShrink: 0,
                              }}
                            ></div>
                            <div
                              className="d-flex justify-content-between align-items-center w-100"
                              style={{ paddingLeft: "16px" }}
                            >
                              <span
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "500",
                                  color: "#8790A1",
                                  fontFamily: "Satoshi",
                                }}
                              >
                                {card.label}
                              </span>
                              <div className="d-flex align-items-baseline">
                                <span
                                  style={{
                                    fontSize: "18px",
                                    fontWeight: "700",
                                    color: "#1E1E1E",
                                    fontFamily: "Satoshi",
                                  }}
                                >
                                  {card.value}
                                </span>
                                <span
                                  style={{
                                    fontSize: "14px",
                                    color: "#8790A1",
                                    marginLeft: "4px",
                                    fontWeight: "500",
                                  }}
                                >
                                  hrs
                                </span>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>

                      <div
                        className="d-flex justify-content-between align-items-center"
                        style={{
                          borderRadius: "16px",
                          padding: "12px 24px",
                          background: "#FFFFFF",
                        }}
                      >
                        <div
                          className="d-flex align-items-center"
                          style={{ gap: "16px" }}
                        >
                          <div
                            style={{
                              fontSize: "14px",
                              fontWeight: "500",
                              color: "#8790A1",
                              fontFamily: "Satoshi",
                            }}
                          >
                            {selectedTicketList.length} tickets selected
                          </div>
                          <div
                            onClick={() => {
                              setClearAllCheckbox(true);
                            }}
                            className="d-flex align-items-center cursor-pointer"
                            style={{
                              height: "40px",
                              borderRadius: "100px",
                              border: "1px solid #F5F5F5",
                              padding: "0 16px",
                              gap: "8px",
                              background: "#FFFFFF",
                            }}
                          >
                            {closeIcon && (
                              <img
                                src={closeIcon}
                                alt="Unselect all"
                                style={{ width: "12px" }}
                              />
                            )}
                            <span
                              style={{
                                fontSize: "14px",
                                fontWeight: "500",
                                color: "#FF4444",
                                fontFamily: "Satoshi",
                              }}
                            >
                              Unselect all
                            </span>
                          </div>
                        </div>
                        <div
                          className="d-flex align-items-center"
                          style={{ gap: "12px" }}
                        >
                          <div
                            onClick={async () => {
                              if (selectedTicketList.length < 2) {
                                setSnackbarMessage(
                                  "Select at least 2 tickets to merge",
                                );
                                setSnackbarStatus(false);
                                handleSnackbarShow();
                                return;
                              }

                              setLoading(true);
                              try {
                                const response = await apiCall(
                                  "post",
                                  "ticket/merge_validate",
                                  {
                                    ticket_ids: selectedTicketList,
                                  },
                                );

                                if (
                                  !response ||
                                  response.data?.success === false ||
                                  response.data?.status === false
                                ) {
                                  setSnackbarMessage(
                                    response?.data?.message ||
                                      "Merge check failed.",
                                  );
                                  setSnackbarStatus(false);
                                  handleSnackbarShow();
                                  setLoading(false);
                                  return;
                                }
                              } catch (error) {
                                setSnackbarMessage(
                                  "Something went wrong during validation.",
                                );
                                setSnackbarStatus(false);
                                handleSnackbarShow();
                                setLoading(false);
                                return;
                              }
                              setLoading(false);

                              const selectedTickets = ticketList.filter((t) =>
                                selectedTicketList.includes(t.id),
                              );

                              const parseTimeToSeconds = (timeStr) => {
                                if (!timeStr || timeStr === "--:--") return 0;
                                const parts = String(timeStr)
                                  .split(":")
                                  .map(Number);
                                if (parts.length === 3)
                                  return (
                                    parts[0] * 3600 + parts[1] * 60 + parts[2]
                                  );
                                if (parts.length === 2)
                                  return parts[0] * 3600 + parts[1] * 60;
                                return 0;
                              };

                              const formatSecondsToHHMM = (totalSeconds) => {
                                const hours = Math.floor(totalSeconds / 3600);
                                const minutes = Math.floor(
                                  (totalSeconds % 3600) / 60,
                                );
                                return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
                              };

                              let totalEstSeconds = 0;
                              let totalWorkSeconds = 0;
                              let earliestCreated = null;
                              let latestExpected = null;
                              let allAttachments = [];

                              selectedTickets.forEach((ticket) => {
                                totalEstSeconds += parseTimeToSeconds(
                                  ticket.est,
                                );
                                totalWorkSeconds += parseTimeToSeconds(
                                  ticket.work_duration || ticket.duration,
                                );

                                if (ticket.created) {
                                  const cDate = moment(ticket.created);
                                  if (
                                    cDate.isValid() &&
                                    (!earliestCreated ||
                                      cDate.isBefore(earliestCreated))
                                  ) {
                                    earliestCreated = cDate;
                                  }
                                }

                                if (ticket.expected || ticket.date) {
                                  const eDate = moment(
                                    ticket.expected || ticket.date,
                                  );
                                  if (
                                    eDate.isValid() &&
                                    (!latestExpected ||
                                      eDate.isAfter(latestExpected))
                                  ) {
                                    latestExpected = eDate;
                                  }
                                }

                                if (Array.isArray(ticket.attachments)) {
                                  allAttachments = [
                                    ...allAttachments,
                                    ...ticket.attachments,
                                  ];
                                }
                              });

                              navigate("/ticket/add", {
                                state: {
                                  mergeTicketIds: selectedTicketList,
                                  listing_type: listingType,
                                  mergeData: {
                                    estimation:
                                      formatSecondsToHHMM(totalEstSeconds),
                                    work_duration:
                                      formatSecondsToHHMM(totalWorkSeconds),
                                    created_date: earliestCreated
                                      ? earliestCreated.format(
                                          "YYYY-MM-DD HH:mm:ss",
                                        )
                                      : null,
                                    expected_date: latestExpected
                                      ? latestExpected.format(
                                          "YYYY-MM-DD HH:mm:ss",
                                        )
                                      : null,
                                    attachments: allAttachments,
                                  },
                                },
                              });
                            }}
                            className="d-flex align-items-center cursor-pointer"
                            style={{
                              height: "44px",
                              borderRadius: "100px",
                              border: "1px solid #E5E5E5",
                              padding: "0 24px",
                              gap: "10px",
                              background: "#FFFFFF",
                            }}
                          >
                            {multiIcon && (
                              <img
                                src={multiIcon}
                                alt="Merge as one"
                                style={{ width: "20px" }}
                              />
                            )}
                            <span
                              style={{
                                fontSize: "14px",
                                fontWeight: "700",
                                color: "#6929E2",
                                fontFamily: "Satoshi",
                              }}
                            >
                              Merge as one
                            </span>
                          </div>
                          <div
                            onClick={() => {
                              setShowBulkAssignUpdate(true);
                            }}
                            className="d-flex align-items-center cursor-pointer"
                            style={{
                              height: "44px",
                              borderRadius: "100px",
                              border: "1px solid #E5E5E5",
                              padding: "0 24px",
                              gap: "10px",
                              background: "#FFFFFF",
                            }}
                          >
                            {checkIcon && (
                              <img
                                src={checkIcon}
                                alt="Bulk assign"
                                style={{ width: "20px" }}
                              />
                            )}
                            <span
                              style={{
                                fontSize: "14px",
                                fontWeight: "700",
                                color: "#6929E2",
                                fontFamily: "Satoshi",
                              }}
                            >
                              Bulk assign
                            </span>
                          </div>
                          <div
                            onClick={() => {
                              setShowBulkStatusUpdate(true);
                            }}
                            className="d-flex align-items-center cursor-pointer"
                            style={{
                              height: "44px",
                              borderRadius: "100px",
                              border: "1px solid #E5E5E5",
                              padding: "0 24px",
                              gap: "10px",
                              background: "#FFFFFF",
                            }}
                          >
                            {editIcon && (
                              <img
                                src={editIcon}
                                alt="Bulk update"
                                style={{ width: "20px" }}
                              />
                            )}
                            <span
                              style={{
                                fontSize: "14px",
                                fontWeight: "700",
                                color: "#6929E2",
                                fontFamily: "Satoshi",
                              }}
                            >
                              Bulk update
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  <div
                    style={{
                      background: "#F6F7F8",
                      margin: "12px",
                      borderRadius: "16px",
                    }}
                  >
                    <Ticketstableview
                      tableData={ticketList}
                      deleteTicket={deleteTicket}
                      rolePermission={pagePermission("Ticket")}
                      onSelectCheckBox={onChangeTicketSelect}
                      clearAllCheckbox={clearAllCheckbox}
                      selectedTab={listingType}
                      setInProgressTicket={setInProgressTicket}
                      setUpdateStatus={setUpdateStatus}
                      cloneTicket={cloneTicket}
                      refreshList={() => {
                        getListData("");
                        getListCount();
                        getTodayCount();
                        getInprogressList();
                        if (selectedTicketList.length > 0) {
                          getSelectedTicketHours();
                        }
                      }}
                      selectedProjectOptions={selectedProjectOptions}
                      handleProjectDropdownChange={handleProjectDropdownChange}
                      selectedComponentOptions={selectedComponentOptions}
                      handleComponentDropdownChange={
                        handleComponentDropdownChange
                      }
                    />
                    <Row
                      className="align-items-center"
                      style={{
                        backgroundColor: "#F6F7F8",
                        margin: "0px",
                        padding: "12px 0px",
                        borderBottomLeftRadius: "16px",
                        borderBottomRightRadius: "16px",
                      }}
                    >
                      <Col>
                        <div className="d-flex align-items-center justify-content-start mx-3">
                          <span
                            style={{
                              fontFamily: "Satoshi",
                              fontSize: "13px",
                              fontWeight: "500",
                              color: "#212129",
                            }}
                          >
                            Records per page :
                          </span>
                          <select
                            className="select3"
                            id="perpage"
                            value={itemsPerPage}
                            onChange={(event) => {
                              setItemsPerPage(Number(event.target.value));
                              setItemOffset(0);
                            }}
                            style={{
                              cursor: "pointer",
                              fontFamily: "Satoshi",
                              fontSize: "14px",
                              fontWeight: "500",
                              lineHeight: "18.9px",
                              color: "#212129",
                              width: "56px",
                              height: "24px",
                              borderRadius: "100px",
                              border: "0.7px solid #E5E5E5",
                              padding: "0 4px",
                              backgroundColor: "#FFFFFF",
                            }}
                          >
                            <option value="5">5</option>
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="30">30</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                          </select>
                        </div>
                      </Col>
                      <Col>
                        <div className="d-flex justify-content-end align-items-center">
                          <ReactPaginate
                            previousLabel={
                              <img src={lar} className="ar3" alt="previous" />
                            }
                            nextLabel={
                              <img src={rar} className="ar3" alt="next" />
                            }
                            breakLabel={"..."}
                            pageCount={Math.max(
                              pageCount + 1,
                              Math.floor(itemOffset / Number(itemsPerPage)) + 1,
                            )}
                            forcePage={Math.floor(
                              itemOffset / Number(itemsPerPage),
                            )}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={3}
                            onPageChange={handlePageClick}
                            containerClassName={"pagination mb-0"}
                            activeClassName={"active"}
                          />
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              )}
              {view === "card" && (
                <div style={{ height: "calc(100%-50%)" }}>
                  <Ticketscardview
                    tableData={statusTicketList}
                    rolePermission={pagePermission("Ticket")}
                    refreshList={() => {
                      getListData("");
                      getListCount();
                      getTodayCount();
                      getInprogressList();
                      if (selectedTicketList.length > 0) {
                        getSelectedTicketHours();
                      }
                    }}
                  />
                </div>
              )}
              {view === "list" && (
                <div style={{ height: "calc(100%-50%)" }}>
                  <Ticketslistview
                    tableData={ticketList}
                    rolePermission={pagePermission("Ticket")}
                    refreshList={() => {
                      getListData("");
                      getListCount();
                      getTodayCount();
                      getInprogressList();
                      if (selectedTicketList.length > 0) {
                        getSelectedTicketHours();
                      }
                    }}
                  />
                </div>
              )}
              {view === "calendar" && (
                <div>
                  <TicketCalendar
                    tableData={calendarTicketList}
                    onChangeDateRange={onChangeDateRange}
                    rolePermission={pagePermission("Ticket")}
                  />
                </div>
              )}
            </div>

            {/* <ReactPaginate
        breakLabel="..."
        nextLabel="next >"
        onPageChange={handlePageClick}
        pageRangeDisplayed={5}
        pageCount={pageCount}
        previousLabel="< previous"
        renderOnZeroPageCount={null}
      /> */}
          </Col>
        </Row>
      </div>
      {isOpenDelete && (
        <div style={modalStyle.overlay}>
          <div
            ref={alertRef}
            style={{
              backgroundColor: "#ffffff",
              padding: "24px",
              borderRadius: "24px",
              boxShadow: "0 12px 40px rgba(0, 0, 0, 0.15)",
              width: "520px",
              textAlign: "center",
            }}
          >
            <div className="d-flex justify-content-between align-items-center mb-3">
              <span
                style={{
                  fontSize: "20px",
                  fontWeight: "700",
                  color: "#212129",
                  fontFamily: "Satoshi",
                }}
              >
                Delete Ticket
              </span>
              <div
                onClick={() => setIsOpenDelete(false)}
                style={{
                  width: "32px",
                  height: "32px",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  border: "1px solid #E5E5E5",
                }}
              >
                <img src={close} alt="close" style={{ width: "12px" }} />
              </div>
            </div>

            <div
              style={{
                marginTop: "16px",
                fontSize: "16px",
                fontWeight: "400",
                color: "#8790A1",
                fontFamily: "Satoshi",
                lineHeight: "1.5",
                marginBottom: "32px",
              }}
            >
              You won’t be able to access your ticket after deleting. Are you
              sure you want to delete?
            </div>

            <div className="d-flex justify-content-center gap-3">
              <div
                onClick={() => setIsOpenDelete(false)}
                style={{
                  cursor: "pointer",
                  width: "158px",
                  height: "44px",
                  borderRadius: "100px",
                  border: "1px solid #E5E5E5",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "16px",
                  fontWeight: "700",
                  color: "#212129",
                  fontFamily: "Satoshi",
                  backgroundColor: "#FFFFFF",
                }}
              >
                Cancel
              </div>
              <div
                onClick={() => deleteTicketApi()}
                style={{
                  cursor: "pointer",
                  width: "158px",
                  height: "44px",
                  borderRadius: "100px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  background: "#FF4444",
                  fontSize: "16px",
                  fontWeight: "700",
                  color: "#FFFFFF",
                  fontFamily: "Satoshi",
                }}
              >
                Delete
              </div>
            </div>
          </div>
        </div>
      )}
      {isFilterOpen && (
        <div
          className="modal-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 2000,
          }}
        >
          <div
            className="modal-content"
            style={{
              position: "relative",
              width: "320px",
              height: "100%",
              marginLeft: "auto",
              backgroundColor: "#fff",
              boxShadow: "0 0 10px rgba(0, 0, 0, 0.3)",
            }}
          >
            <FilterPanel
              isOpen={isFilterOpen}
              onClose={() => setIsFilterOpen(false)}
            />
          </div>
        </div>
      )}
      <ToastContainer position="top-end">
        <Toast
          className="d-inline-block m-1"
          bg={snackbarStatus === true ? "success" : "danger"}
          show={showSnackbar}
          onClose={handleSnackbarClose}
          delay={3000}
          autohide
        >
          {/*  <Toast.Header>
            <strong className="mr-auto">Snackbar Title</strong>
          </Toast.Header> */}
          <Toast.Body style={{ color: "#ffffff" }}>
            {snackbarMessage}
          </Toast.Body>
        </Toast>
      </ToastContainer>
      <LoaderModal show={loading} />
    </Container>
  );
}
const Timer = ({ initialSeconds }) => {
  const [secondsLeft, setSecondsLeft] = useState(initialSeconds);

  useEffect(() => {
    const timerId = setInterval(() => {
      setSecondsLeft((prev) => (prev >= 0 ? prev + 1 : 0));
    }, 1000);

    return () => clearInterval(timerId);
  }, []);

  return (
    <div /* style={{ marginBottom: "10px" }} */>
      {/* <span>{formatDuration(secondsLeft)}</span> */}
      <p className="style-justify-start">
        <span className="timm3" style={{ minWidth: "65px" }}>
          {formatDuration(secondsLeft) ?? "00:00"}
        </span>{" "}
        <span>hrs</span>
      </p>
    </div>
  );
};

const formatDuration = (totalSeconds) => {
  const h = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
  const m = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, "0");
  const s = String(totalSeconds % 60).padStart(2, "0");
  return `${h}:${m}:${s}`;
};

const parseDuration = (timeStr) => {
  const [hours, minutes, seconds] = timeStr.split(":").map(Number);
  return hours * 3600 + minutes * 60 + seconds;
};
